// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Big from "@wino/accounting/src/Big.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Sale from "./Sale.res.js";
import * as View from "../../primitives/View.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as BigJs from "big.js";
import * as Loyalty from "../Loyalty/Loyalty.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Customer from "../Customer/Customer.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as DeviceName from "../Device/DeviceName.res.js";
import * as LegacyIcon from "../../resources/images-and-icons/LegacyIcon.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as SalesRoutes from "../../app/Sales/SalesRoutes.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as PaymentMethod from "../PaymentMethod.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StringHelpers from "../../helpers/StringHelpers.res.js";
import * as Client from "@apollo/client";
import * as CustomerRoutes from "../../app/Customer/CustomerRoutes.res.js";
import * as LabelTableCell from "../TableCell/LabelTableCell.res.js";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as ProgressPieIcon from "../../resources/feedback-indicators/ProgressPieIcon.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ElectronicInvoicing from "../ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as ElectronicInvoicingWorkflowState from "../ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
function isDatetimeBackdated(datetime) {
  if (datetime.getUTCHours() === 0 && datetime.getUTCMinutes() === 0 && datetime.getUTCSeconds() === 0) {
    return datetime.getUTCMilliseconds() === 0;
  } else {
    return false;
  }
}
function groupPaymentMethodsByOccurrence(paymentMethods) {
  return Stdlib_Array.reduce(paymentMethods, [], (acc, method) => {
    let index = Stdlib_Array.findIndexOpt(acc, param => PaymentMethod.equal(param[0], method));
    if (index !== undefined) {
      return acc.map((param, i) => {
        let count = param[1];
        let method = param[0];
        if (i === index) {
          return [method, count + 1 | 0];
        } else {
          return [method, count];
        }
      });
    } else {
      return acc.concat([[method, 1]]);
    }
  });
}
let saleTypeValues = ["Invoice", "DeliveryNote", "Quote", "CreditNote", "SalesReceipt", "RefundReceipt"];
function svgFromSaleType(saleType) {
  switch (saleType) {
    case "SalesReceipt":
      return JsxRuntime.jsxs("svg", {
        children: [JsxRuntime.jsx("path", {
          d: "M3.5 4.1999C3.5 4.03422 3.63431 3.8999 3.8 3.8999H6.2C6.36569 3.8999 6.5 4.03422 6.5 4.1999C6.5 4.36559 6.36569 4.4999 6.2 4.4999H3.8C3.63431 4.4999 3.5 4.36559 3.5 4.1999Z",
          fill: "#25243A"
        }), JsxRuntime.jsx("path", {
          d: "M3.8 6.2999C3.63431 6.2999 3.5 6.43422 3.5 6.5999C3.5 6.76559 3.63431 6.8999 3.8 6.8999H6.2C6.36569 6.8999 6.5 6.76559 6.5 6.5999C6.5 6.43422 6.36569 6.2999 6.2 6.2999H3.8Z",
          fill: "#25243A"
        }), JsxRuntime.jsx("path", {
          d: "M1.06636 1.12586C1.10021 0.992936 1.21991 0.899902 1.35708 0.899902H9.2C9.28915 0.899902 9.37367 0.939547 9.43067 1.00809C9.48767 1.07663 9.51123 1.16698 9.49497 1.25462C8.89043 4.51321 8.89328 7.17843 9.49216 9.74612C9.51306 9.83573 9.49168 9.92997 9.43417 10.0018L8.64488 10.9874C8.58814 11.0583 8.50236 11.0996 8.41158 11.0999C8.32081 11.1002 8.23479 11.0593 8.17764 10.9888L7.61323 10.2923L7.05608 10.9875C6.99929 11.0584 6.91347 11.0997 6.82267 11.0999C6.73187 11.1001 6.64586 11.0592 6.58875 10.9886L6.02498 10.2917L5.46327 10.9882C5.40633 11.0588 5.3205 11.0999 5.2298 11.0999C5.13909 11.0999 5.05325 11.0589 4.99628 10.9883L4.43565 10.2936L3.88226 10.987C3.82556 11.0581 3.73968 11.0996 3.64877 11.0999C3.55786 11.1002 3.47171 11.0593 3.41454 10.9886L2.85029 10.2911L2.28506 10.9887C2.2279 11.0593 2.14188 11.1002 2.05109 11.0999C1.96029 11.0996 1.87451 11.0583 1.81776 10.9874L1.02523 9.99749C0.995662 9.96055 0.975247 9.91714 0.965655 9.87081C0.282728 6.57201 0.380433 3.81911 1.06636 1.12586ZM1.59171 1.4999C0.985016 4.01013 0.908222 6.58914 1.53874 9.67886L2.05334 10.3216L2.61736 9.62542C2.67435 9.55508 2.76005 9.51423 2.85057 9.51426C2.9411 9.5143 3.02677 9.55521 3.0837 9.62559L3.64619 10.3209L4.19985 9.62714C4.2566 9.55603 4.34254 9.51451 4.43352 9.51426C4.52449 9.51402 4.61067 9.55506 4.6678 9.62586L5.22967 10.3221L5.79109 9.62594C5.84799 9.55538 5.93374 9.51433 6.02438 9.51426C6.11502 9.51419 6.20084 9.55511 6.25784 9.62558L6.82089 10.3216L7.37785 9.62665C7.4346 9.55583 7.52037 9.51451 7.61113 9.51426C7.70188 9.51402 7.78787 9.55487 7.84501 9.62538L8.40931 10.3217L8.87522 9.7399C8.30791 7.2143 8.29978 4.6044 8.84118 1.4999H1.59171Z",
          fill: "#25243A"
        })],
        style: {
          marginTop: "0.5px"
        },
        height: "13",
        width: "13",
        viewBox: "0 0 9 11"
      });
    case "CreditNote":
      return JsxRuntime.jsx("svg", {
        children: JsxRuntime.jsx("path", {
          d: "M17.5771 4.44434C17.5771 4.05221 17.4568 3.66879 17.2314 3.34473C17.006 3.02052 16.6859 2.77034 16.3125 2.62891C15.9391 2.48749 15.5305 2.46187 15.1416 2.55469C14.7526 2.64758 14.4018 2.85517 14.1357 3.14844L14.1318 3.15332C14.0615 3.22879 13.976 3.28821 13.8818 3.3291C13.7875 3.36999 13.6856 3.3916 13.583 3.3916C13.4804 3.3916 13.3785 3.36998 13.2842 3.3291C13.1902 3.2883 13.1054 3.22857 13.0352 3.15332L13.0303 3.14844C12.7642 2.85517 12.4134 2.64758 12.0244 2.55469C11.6355 2.4619 11.2269 2.48751 10.8535 2.62891C10.4802 2.77035 10.16 3.02055 9.93457 3.34473C9.70925 3.66877 9.58887 4.05223 9.58887 4.44434C9.58905 5.29626 10.177 6.10228 10.7871 6.70606L13.583 9.27637L16.377 6.70606C16.663 6.42299 16.9709 6.04981 17.2031 5.6416C17.4377 5.22908 17.577 4.81505 17.5771 4.44434ZM17.2373 7.78321C16.8912 7.7736 16.5567 7.90112 16.3066 8.13477C16.299 8.14193 16.2892 8.14673 16.2812 8.15332L12.5283 11.6035C12.5122 11.6183 12.494 11.6303 12.4766 11.6426C12.0486 12.0498 11.4795 12.2783 10.8867 12.2783H9.08887C8.81295 12.2782 8.58904 12.0542 8.58887 11.7783C8.58887 11.5023 8.81284 11.2785 9.08887 11.2783H10.8867C11.2326 11.2783 11.5637 11.1416 11.8066 10.9014C12.0491 10.6614 12.1846 10.3369 12.1846 10C12.1845 9.66311 12.0492 9.33861 11.8066 9.09864C11.5637 8.8584 11.2326 8.72267 10.8867 8.72266H8.19043C7.75496 8.72266 7.47735 8.8635 7.33008 9.05762C7.31393 9.07892 7.29669 9.09972 7.27734 9.11817L2.61621 13.5625L5.5166 16.4297L6.57324 15.5137C6.96677 15.0334 7.56884 14.833 8.19043 14.833H11.7852C12.6522 14.833 13.4069 14.5242 13.9277 13.9355L13.959 13.9033L18.0928 9.99219L18.0947 9.99024C18.3446 9.75668 18.4893 9.43599 18.499 9.09864C18.5087 8.76126 18.3825 8.43252 18.1465 8.18555C17.9103 7.93861 17.5834 7.79288 17.2373 7.78321ZM18.5771 4.44532C18.577 5.05194 18.3551 5.63845 18.0723 6.13575C17.9334 6.37993 17.7744 6.61081 17.6094 6.82227C18.0878 6.90803 18.5309 7.14018 18.8701 7.49512C19.2895 7.9341 19.5163 8.52099 19.499 9.12696C19.4817 9.73195 19.2216 10.3033 18.7793 10.7178L18.7803 10.7188L14.6543 14.6201C13.918 15.4378 12.885 15.833 11.7852 15.833H8.19043C7.75489 15.833 7.47733 15.9748 7.33008 16.1689C7.30908 16.1966 7.28504 16.2224 7.25879 16.2451L6.22949 17.1357L6.74414 17.6445C6.94048 17.8387 6.94222 18.1552 6.74805 18.3516C6.55386 18.5478 6.23733 18.5496 6.04101 18.3555L0.648436 13.0225C0.452112 12.8283 0.450416 12.5118 0.64453 12.3154C0.838704 12.1191 1.15522 12.1174 1.35156 12.3115L1.9043 12.8584L6.5664 8.41211C6.95977 7.92536 7.565 7.72266 8.19043 7.72266H10.415L10.0986 7.43164C10.0942 7.42759 10.0902 7.42315 10.0859 7.41895C9.44212 6.78225 8.58904 5.72547 8.58887 4.44532C8.58873 3.84805 8.77172 3.26462 9.11328 2.77344C9.45479 2.28236 9.93901 1.9068 10.5 1.69434C11.0609 1.48195 11.6733 1.44273 12.2568 1.58203C12.7538 1.70071 13.2101 1.94474 13.583 2.28809C13.9559 1.94471 14.4122 1.70072 14.9092 1.58203C15.4927 1.4427 16.1051 1.48198 16.666 1.69434C17.227 1.90679 17.7112 2.28239 18.0527 2.77344C18.3943 3.26462 18.5773 3.84804 18.5771 4.44532Z",
          fill: "#D92964"
        }),
        height: "15",
        width: "15",
        viewBox: "0 0 20 20"
      });
    case "RefundReceipt":
      return JsxRuntime.jsxs("svg", {
        children: [JsxRuntime.jsx("path", {
          d: "M8.96971 10.8V7.78889L7.95486 8.8342C7.8394 8.9529 7.64944 8.95546 7.53065 8.84006C7.41195 8.7246 7.40939 8.53464 7.52479 8.41584L9.05467 6.84085L9.10096 6.80217C9.15035 6.76853 9.20903 6.75005 9.26971 6.75002C9.35069 6.75002 9.42827 6.78282 9.48475 6.84085L11.0152 8.41584C11.1306 8.53468 11.1276 8.72462 11.0088 8.84006C10.8899 8.9555 10.7 8.95302 10.5846 8.8342L9.56971 7.78889V10.8C9.56971 10.9657 9.43539 11.1 9.26971 11.1C9.10408 11.1 8.96971 10.9657 8.96971 10.8Z",
          fill: "#D92964"
        }), JsxRuntime.jsx("path", {
          d: "M10.1998 0.900024C10.2889 0.900024 10.3736 0.93988 10.4306 1.00842C10.4875 1.07689 10.5107 1.16702 10.4945 1.25452C10.341 2.08195 10.2271 2.87134 10.1517 3.62991C10.1117 4.03278 10.0825 4.42713 10.0644 4.81409C10.0566 4.97951 9.91636 5.10709 9.75094 5.09944C9.58543 5.09171 9.45727 4.95147 9.465 4.78596C9.48359 4.38802 9.51364 3.98299 9.55465 3.57014C9.62094 2.90272 9.71774 2.21449 9.84234 1.50002H2.59312C1.98629 4.0106 1.90848 6.58947 2.53922 9.67971L3.05308 10.3219L3.61734 9.62581L3.6648 9.57835C3.71719 9.5372 3.78266 9.51445 3.85055 9.51448C3.94099 9.51457 4.02686 9.55548 4.08375 9.62581L4.64566 10.3207L5.19937 9.62698C5.25609 9.55593 5.34226 9.51476 5.43316 9.51448C5.52409 9.51423 5.6104 9.55508 5.66754 9.62581L6.46324 10.6114C6.56722 10.7402 6.54683 10.9291 6.41812 11.0332C6.28927 11.1372 6.10034 11.1174 5.99625 10.9887L5.43492 10.2932L4.8818 10.9869C4.8251 11.058 4.73948 11.0997 4.64859 11.1C4.55768 11.1003 4.47139 11.0594 4.41422 10.9887L3.84937 10.2908L3.28453 10.9887C3.22738 11.0592 3.14152 11.1003 3.05074 11.1C2.95999 11.0997 2.87426 11.0584 2.81754 10.9875L2.02476 9.99788C1.99519 9.96094 1.97518 9.91706 1.96558 9.87073C1.28271 6.57205 1.38049 3.81935 2.06637 1.1262L2.08277 1.07815C2.13024 0.971288 2.23697 0.900024 2.35699 0.900024H10.1998Z",
          fill: "#D92964"
        }), JsxRuntime.jsx("path", {
          d: "M7.19976 3.90002C7.36545 3.90002 7.49976 4.03434 7.49976 4.20002C7.49976 4.36571 7.36545 4.50002 7.19976 4.50002H4.79976C4.63408 4.50002 4.49976 4.36571 4.49976 4.20002C4.49976 4.03434 4.63408 3.90002 4.79976 3.90002H7.19976Z",
          fill: "#D92964"
        }), JsxRuntime.jsx("path", {
          d: "M5.99976 6.30002C6.16545 6.30002 6.29976 6.43434 6.29976 6.60002C6.29976 6.76571 6.16545 6.90002 5.99976 6.90002H4.79976C4.63408 6.90002 4.49976 6.76571 4.49976 6.60002C4.49976 6.43434 4.63408 6.30002 4.79976 6.30002H5.99976Z",
          fill: "#D92964"
        })],
        height: "13",
        width: "13",
        viewBox: "0 0 11 10"
      });
    case "DeliveryNote":
      return JsxRuntime.jsx("svg", {
        children: JsxRuntime.jsx("path", {
          d: "M5.10059 0C5.18008 5.1687e-05 5.25629 0.0316757 5.3125 0.0878906L7.71289 2.4873C7.769 2.54346 7.80068 2.61984 7.80078 2.69922V9.89941C7.80078 10.0651 7.66569 10.1992 7.5 10.1992H0.300781C0.135096 10.1992 0 10.0651 0 9.89941V0.299805C0 0.134119 0.135096 0 0.300781 0H5.10059ZM0.600586 9.59961H7.2002V3H5.10059C4.9349 3 4.80078 2.8649 4.80078 2.69922V0.599609H0.600586V9.59961ZM2.85547 6.68066C2.97634 6.56753 3.16603 6.57355 3.2793 6.69434C3.39256 6.81515 3.38632 7.00483 3.26562 7.11816L2.41992 7.91113L1.89551 7.41895C1.77463 7.30563 1.76852 7.11501 1.88184 6.99414C1.99516 6.87359 2.18489 6.86733 2.30566 6.98047L2.41992 7.08887L2.85547 6.68066ZM5.7002 7.19922C5.86588 7.19922 6 7.33431 6 7.5C5.99979 7.66551 5.86575 7.7998 5.7002 7.7998H4.5C4.33462 7.79959 4.20041 7.66538 4.2002 7.5C4.2002 7.33444 4.33449 7.19943 4.5 7.19922H5.7002ZM2.85547 4.28027C2.97628 4.16739 3.16607 4.17342 3.2793 4.29395C3.39262 4.41482 3.3865 4.60543 3.26562 4.71875L2.41992 5.51074L1.89551 5.01855C1.77464 4.90524 1.76852 4.7156 1.88184 4.59473C1.99515 4.47385 2.18479 4.46774 2.30566 4.58105L2.41992 4.68848L2.85547 4.28027ZM5.7002 4.7998C5.86588 4.7998 6 4.93392 6 5.09961C6 5.26529 5.86588 5.39941 5.7002 5.39941H4.5C4.33449 5.3992 4.2002 5.26516 4.2002 5.09961C4.2002 4.93405 4.33449 4.80002 4.5 4.7998H5.7002ZM5.40039 2.39941H6.77539L5.40039 1.02344V2.39941Z",
          fill: "#25243A"
        }),
        height: "13",
        width: "10",
        viewBox: "0 0 9 9"
      });
    case "Invoice":
    case "Quote":
      break;
  }
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsx("path", {
      d: "M11.0998 9.19971C11.0998 9.1391 11.0752 9.08024 11.0307 9.03623C10.9859 8.9921 10.9244 8.9665 10.8596 8.9665H5.45957C5.39488 8.96657 5.33373 8.99219 5.28906 9.03623C5.24451 9.08024 5.21997 9.1391 5.21992 9.19971V9.7335C5.21987 10.0092 5.13509 10.2755 4.98144 10.4999H10.3199C10.5278 10.4999 10.7265 10.4183 10.8725 10.2743C11.0183 10.1303 11.0997 9.93552 11.0998 9.7335V9.19971ZM7.61992 5.6999C7.78555 5.69997 7.91992 5.83426 7.91992 5.9999C7.91992 6.16555 7.78555 6.29984 7.61992 6.2999H4.91992C4.75424 6.2999 4.61992 6.16559 4.61992 5.9999C4.61992 5.83422 4.75424 5.6999 4.91992 5.6999H7.61992ZM7.61992 3.5665C7.78553 3.56657 7.91989 3.70089 7.91992 3.8665C7.91992 4.03215 7.78555 4.16644 7.61992 4.1665H4.91992C4.75424 4.1665 4.61992 4.03219 4.61992 3.8665C4.61996 3.70085 4.75426 3.5665 4.91992 3.5665H7.61992ZM2.45957 2.26631C2.4595 2.06428 2.37862 1.8695 2.23281 1.72549C2.08682 1.58133 1.88772 1.4999 1.67969 1.4999C1.47178 1.49993 1.2731 1.58147 1.12715 1.72549C0.981337 1.8695 0.899874 2.06428 0.899805 2.26631V3.3333C0.899822 3.39395 0.924357 3.45274 0.968945 3.49678C1.01367 3.54095 1.0752 3.5665 1.14004 3.5665H2.45957V2.26631ZM3.05957 9.7335C3.05964 9.93552 3.1411 10.1303 3.28691 10.2743C3.4329 10.4184 3.63204 10.4999 3.84004 10.4999C4.04793 10.4998 4.24665 10.4183 4.39258 10.2743C4.53839 10.1303 4.61985 9.93552 4.61992 9.7335V9.19971C4.61997 8.97755 4.7093 8.76502 4.86719 8.60908C5.02493 8.45336 5.23813 8.36657 5.45957 8.3665H9.47969V2.26631C9.47962 2.06428 9.39874 1.8695 9.25293 1.72549C9.12514 1.59928 8.95665 1.52098 8.77715 1.50342L8.6998 1.4999H2.82168C2.97528 1.72428 3.05952 1.99067 3.05957 2.26631V9.7335ZM10.0797 8.3665H10.8596C11.0811 8.3665 11.2947 8.45327 11.4525 8.60908C11.6104 8.76502 11.6998 8.97755 11.6998 9.19971V9.7335C11.6997 10.0971 11.5534 10.4449 11.2943 10.7009C11.0353 10.9567 10.6847 11.0999 10.3199 11.0999H3.84004C3.47523 11.0999 3.12412 10.9568 2.86504 10.7009C2.606 10.445 2.45964 10.097 2.45957 9.7335V4.1665H1.14004C0.918459 4.1665 0.704877 4.07978 0.54707 3.92393C0.389151 3.76796 0.299822 3.5555 0.299805 3.3333V2.26631C0.299875 1.90275 0.44616 1.55486 0.705273 1.29893C0.964324 1.04307 1.31493 0.899933 1.67969 0.899902H8.6998L8.83574 0.906348C9.1508 0.937222 9.44751 1.07502 9.67422 1.29893C9.93336 1.55487 10.0796 1.90273 10.0797 2.26631V8.3665Z",
      fill: "#25243A"
    }),
    height: "13",
    width: "13",
    viewBox: "0 0 12 10"
  });
}
function renderTransformedSaleTooltipSvg(saleType) {
  let formattedTooltipText;
  switch (saleType) {
    case "Invoice":
      formattedTooltipText = I18n.t("Issued from a receipt");
      break;
    case "SalesReceipt":
      formattedTooltipText = I18n.t("Transformed into invoice");
      break;
    case "CreditNote":
      formattedTooltipText = I18n.t("Transformed from invoice");
      break;
    default:
      formattedTooltipText = "";
  }
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx("svg", {
      children: JsxRuntime.jsx("path", {
        d: "M6.77255742,9.78138085 L6.86213558,9.79225636 C7.13219931,9.84987748 7.30441807,10.1155185 7.24679695,10.3855823 C7.01665848,11.4642155 6.41259534,12.3505288 5.55164239,13.0601156 L5.34845403,13.2207364 C5.32077498,13.2417311 5.29297762,13.2624688 5.26506962,13.282951 L17.28125,13.28125 C17.5573924,13.28125 17.78125,13.5051076 17.78125,13.78125 C17.78125,14.0573924 17.5573924,14.28125 17.28125,14.28125 L5.12075,14.2811335 L5.35114555,14.4532045 C6.24809057,15.1581025 6.89687627,15.9800249 7.18156309,16.9292247 L7.24508231,17.1691822 C7.30697562,17.438299 7.13898783,17.7066357 6.86987107,17.768529 C6.60075431,17.8304223 6.33241763,17.6624345 6.27052432,17.3933178 C6.08759208,16.5979147 5.54117274,15.8744012 4.73323976,15.2394567 C4.36585819,14.9507361 3.96980364,14.7005752 3.57379314,14.4911667 L3.31904909,14.3619248 L3.12838928,14.273892 C2.89406794,14.2290563 2.71875,14.025627 2.71875,13.78125 C2.71875,13.5357901 2.89562516,13.3316416 3.12887437,13.2893057 L3.14775,13.2871335 L3.20977248,13.2657597 C3.3076688,13.2300149 3.44113414,13.176162 3.60080708,13.1031188 C3.99124351,12.9245115 4.3818497,12.6987897 4.74412533,12.4240013 C5.53612454,11.8232648 6.07625346,11.0794072 6.26880968,10.1769177 C6.3136261,9.96686817 6.48428175,9.81600877 6.68498257,9.78644413 L6.77255742,9.78138085 Z M14.1816887,2.53518677 C14.5150751,3.1250057 14.9735248,3.7009764 15.5259566,4.25249003 C15.9631917,4.68899842 16.4332909,5.08493741 16.9032253,5.43183551 C17.134673,5.60268652 17.3220738,5.73010042 17.4469386,5.80981523 C17.6416527,5.87772507 17.78125,6.06318519 17.78125,6.28125 C17.78125,6.51209918 17.6248047,6.70640861 17.4121526,6.76393981 L17.2609602,6.84025659 L16.9489502,7.0139921 C16.5493255,7.24636299 16.1497363,7.51474363 15.7789627,7.81391878 C14.9594087,8.47521235 14.4073862,9.18479684 14.2320378,9.90024333 C14.1663037,10.1684478 13.895593,10.3325825 13.6273885,10.2668484 C13.359184,10.2011143 13.1950494,9.93040361 13.2607834,9.66219913 C13.498015,8.69426068 14.176759,7.82178502 15.1510014,7.03567417 C15.2594395,6.94817611 15.3697479,6.86326687 15.4814357,6.78098437 L3.21875,6.78125 C2.94260763,6.78125 2.71875,6.55739237 2.71875,6.28125 C2.71875,6.00510763 2.94260763,5.78125 3.21875,5.78125 L15.7267876,5.78199919 C15.4170871,5.52677652 15.1121319,5.25239191 14.8194382,4.96018468 C14.2070224,4.34878674 13.6932951,3.70336843 13.3111325,3.02725569 C13.1752514,2.78685823 13.2599787,2.48182419 13.5003761,2.34594311 C13.7407736,2.21006203 14.0458077,2.2947893 14.1816887,2.53518677 Z",
        fill: "#25243A"
      }),
      style: {
        zIndex: "3"
      },
      height: "13",
      width: "15",
      viewBox: "0 0 20 20"
    }),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: formattedTooltipText
    }),
    delay: 0
  });
}
let Raw = {};
let query = Client.gql(["query SalesListInvoicesQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputInvoicesQueryFilter, $orderBy: [InputInvoicesQueryOrderBy!])  {\ninvoices(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nparentQuote  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\nsalesReceipt  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\ncreditNotes  {\n__typename  \nid  \nname  \ncreatedAt  \ntotalAmountIncludingTaxes  \n}\n\ndeliveryNotes  {\n__typename  \nid  \nname  \ndate  \nstatus  \n}\n\ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\nissueDate  \ndueDate  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntaxesIncluded  \nstatus  \npayments  {\n__typename  \nid  \nmethod  \ndate  \namountReceived  \namountReturned  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\nelectronicInvoicingWorkflowState  {\n...ElectronicInvoicingWorkflowStateResultFragment   \n}\n\n}\n\n}\n\n}\n\n}\n", ""], ElectronicInvoicingWorkflowState.ResultFragment.query);
function parse(value) {
  let value$1 = value.invoices;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    invoices: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.parentQuote;
        let value$3 = value$1.salesReceipt;
        let value$4 = value$1.creditNotes;
        let value$5 = value$1.deliveryNotes;
        let value$6 = value$1.customerAddress;
        let value$7 = value$1.customerCity;
        let value$8 = value$1.customerPostalCode;
        let value$9 = value$1.customerCountry;
        let value$10 = value$1.customerEmail;
        let value$11 = value$1.customerIntraCommunityVAT;
        let value$12 = value$1.customerPhoneNumber;
        let value$13 = value$1.customer;
        let tmp;
        if (value$13 == null) {
          tmp = undefined;
        } else {
          let value$14 = value$13.kind;
          let tmp$1;
          switch (value$14) {
            case "BUSINESS":
              tmp$1 = "BUSINESS";
              break;
            case "CONSUMER":
              tmp$1 = "CONSUMER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = {
            __typename: value$13.__typename,
            id: value$13.id,
            kind: tmp$1,
            hasSubscribedToLoyaltyProgram: value$13.hasSubscribedToLoyaltyProgram
          };
        }
        let value$15 = value$1.dueDate;
        let value$16 = value$1.status;
        let tmp$2;
        switch (value$16) {
          case "DRAFT":
            tmp$2 = "DRAFT";
            break;
          case "PAID":
            tmp$2 = "PAID";
            break;
          case "UNPAID":
            tmp$2 = "UNPAID";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$17 = value$1.payments;
        let value$18 = value$1.device;
        let value$19 = value$1.shop;
        let value$20 = value$1.electronicInvoicingWorkflowState;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            parentQuote: !(value$2 == null) ? {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              createdAt: Scalar.Datetime.parse(value$2.createdAt)
            } : undefined,
            salesReceipt: !(value$3 == null) ? {
              __typename: value$3.__typename,
              id: value$3.id,
              name: value$3.name,
              createdAt: Scalar.Datetime.parse(value$3.createdAt)
            } : undefined,
            creditNotes: value$4.map(value => ({
              __typename: value.__typename,
              id: value.id,
              name: value.name,
              createdAt: Scalar.Datetime.parse(value.createdAt),
              totalAmountIncludingTaxes: value.totalAmountIncludingTaxes
            })),
            deliveryNotes: value$5.map(value => {
              let value$1 = value.status;
              let tmp;
              switch (value$1) {
                case "DRAFT":
                  tmp = "DRAFT";
                  break;
                case "PUBLISHED":
                  tmp = "PUBLISHED";
                  break;
                default:
                  throw {
                    RE_EXN_ID: "Not_found",
                    Error: new Error()
                  };
              }
              return {
                __typename: value.__typename,
                id: value.id,
                name: value.name,
                date: Scalar.Datetime.parse(value.date),
                status: tmp
              };
            }),
            customerName: value$1.customerName,
            customerAddress: !(value$6 == null) ? value$6 : undefined,
            customerCity: !(value$7 == null) ? value$7 : undefined,
            customerPostalCode: !(value$8 == null) ? value$8 : undefined,
            customerCountry: !(value$9 == null) ? value$9 : undefined,
            customerEmail: !(value$10 == null) ? value$10 : undefined,
            customerIntraCommunityVAT: !(value$11 == null) ? value$11 : undefined,
            customerPhoneNumber: !(value$12 == null) ? value$12 : undefined,
            customer: tmp,
            issueDate: Scalar.Datetime.parse(value$1.issueDate),
            dueDate: !(value$15 == null) ? Scalar.Datetime.parse(value$15) : undefined,
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            taxesIncluded: value$1.taxesIncluded,
            status: tmp$2,
            payments: value$17.map(value => {
              let value$1 = value.method;
              let tmp;
              switch (value$1) {
                case "AMEX":
                  tmp = "AMEX";
                  break;
                case "BANK_TRANSFER":
                  tmp = "BANK_TRANSFER";
                  break;
                case "BARNABY":
                  tmp = "BARNABY";
                  break;
                case "CASH":
                  tmp = "CASH";
                  break;
                case "CHEQUE":
                  tmp = "CHEQUE";
                  break;
                case "CONTACTLESS_AMEX":
                  tmp = "CONTACTLESS_AMEX";
                  break;
                case "CONTACTLESS_DEBIT_CARD":
                  tmp = "CONTACTLESS_DEBIT_CARD";
                  break;
                case "CREDIT_MEMO":
                  tmp = "CREDIT_MEMO";
                  break;
                case "DEBIT_CARD":
                  tmp = "DEBIT_CARD";
                  break;
                case "DISTANCE_SELLING":
                  tmp = "DISTANCE_SELLING";
                  break;
                case "EUSKO_CASH":
                  tmp = "EUSKO_CASH";
                  break;
                case "EUSKO_DIGITAL":
                  tmp = "EUSKO_DIGITAL";
                  break;
                case "GIFT_VOUCHER":
                  tmp = "GIFT_VOUCHER";
                  break;
                case "LESHABITUES":
                  tmp = "LESHABITUES";
                  break;
                case "LYDIA":
                  tmp = "LYDIA";
                  break;
                case "PAYPAL":
                  tmp = "PAYPAL";
                  break;
                case "TICKET_RESTAURANT":
                  tmp = "TICKET_RESTAURANT";
                  break;
                case "TOWN_HALL_GIFT_VOUCHER":
                  tmp = "TOWN_HALL_GIFT_VOUCHER";
                  break;
                case "WINO_PAY":
                  tmp = "WINO_PAY";
                  break;
                default:
                  throw {
                    RE_EXN_ID: "Not_found",
                    Error: new Error()
                  };
              }
              return {
                __typename: value.__typename,
                id: value.id,
                method: tmp,
                date: Scalar.Datetime.parse(value.date),
                amountReceived: value.amountReceived,
                amountReturned: value.amountReturned
              };
            }),
            device: {
              __typename: value$18.__typename,
              id: value$18.id,
              name: value$18.name,
              slug: value$18.slug
            },
            shop: {
              __typename: value$19.__typename,
              id: value$19.id,
              name: value$19.name
            },
            electronicInvoicingWorkflowState: ElectronicInvoicingWorkflowState.ResultFragment.verifyArgsAndParse("ElectronicInvoicingWorkflowStateResultFragment", value$20)
          }
        };
      })
    }
  };
}
function serialize(value) {
  let value$1 = value.invoices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.electronicInvoicingWorkflowState;
    let electronicInvoicingWorkflowState = ElectronicInvoicingWorkflowState.ResultFragment.serialize(value$2);
    let value$3 = value$1.shop;
    let value$4 = value$3.name;
    let value$5 = value$3.id;
    let value$6 = value$3.__typename;
    let shop = {
      __typename: value$6,
      id: value$5,
      name: value$4
    };
    let value$7 = value$1.device;
    let value$8 = value$7.slug;
    let value$9 = value$7.name;
    let value$10 = value$7.id;
    let value$11 = value$7.__typename;
    let device = {
      __typename: value$11,
      id: value$10,
      name: value$9,
      slug: value$8
    };
    let value$12 = value$1.payments;
    let payments = value$12.map(value => {
      let value$1 = value.amountReturned;
      let value$2 = value.amountReceived;
      let value$3 = value.date;
      let value$4 = Scalar.Datetime.serialize(value$3);
      let value$5 = value.method;
      let method_ = value$5 === "LESHABITUES" ? "LESHABITUES" : value$5 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$5 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$5 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$5 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$5 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$5 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$5 === "CHEQUE" ? "CHEQUE" : value$5 === "LYDIA" ? "LYDIA" : value$5 === "DEBIT_CARD" ? "DEBIT_CARD" : value$5 === "EUSKO_CASH" ? "EUSKO_CASH" : value$5 === "BARNABY" ? "BARNABY" : value$5 === "PAYPAL" ? "PAYPAL" : value$5 === "AMEX" ? "AMEX" : value$5 === "CASH" ? "CASH" : value$5 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$5 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$5 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
      let value$6 = value.id;
      let value$7 = value.__typename;
      return {
        __typename: value$7,
        id: value$6,
        method: method_,
        date: value$4,
        amountReceived: value$2,
        amountReturned: value$1
      };
    });
    let value$13 = value$1.status;
    let status = value$13 === "UNPAID" ? "UNPAID" : value$13 === "PAID" ? "PAID" : "DRAFT";
    let value$14 = value$1.taxesIncluded;
    let value$15 = value$1.totalAmountExcludingTaxes;
    let value$16 = value$1.totalAmountIncludingTaxes;
    let value$17 = value$1.dueDate;
    let dueDate = value$17 !== undefined ? Scalar.Datetime.serialize(value$17) : null;
    let value$18 = value$1.issueDate;
    let value$19 = Scalar.Datetime.serialize(value$18);
    let value$20 = value$1.customer;
    let customer;
    if (value$20 !== undefined) {
      let value$21 = value$20.hasSubscribedToLoyaltyProgram;
      let value$22 = value$20.kind;
      let kind = value$22 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
      let value$23 = value$20.id;
      let value$24 = value$20.__typename;
      customer = {
        __typename: value$24,
        id: value$23,
        kind: kind,
        hasSubscribedToLoyaltyProgram: value$21
      };
    } else {
      customer = null;
    }
    let value$25 = value$1.customerPhoneNumber;
    let customerPhoneNumber = value$25 !== undefined ? value$25 : null;
    let value$26 = value$1.customerIntraCommunityVAT;
    let customerIntraCommunityVAT = value$26 !== undefined ? value$26 : null;
    let value$27 = value$1.customerEmail;
    let customerEmail = value$27 !== undefined ? value$27 : null;
    let value$28 = value$1.customerCountry;
    let customerCountry = value$28 !== undefined ? value$28 : null;
    let value$29 = value$1.customerPostalCode;
    let customerPostalCode = value$29 !== undefined ? value$29 : null;
    let value$30 = value$1.customerCity;
    let customerCity = value$30 !== undefined ? value$30 : null;
    let value$31 = value$1.customerAddress;
    let customerAddress = value$31 !== undefined ? value$31 : null;
    let value$32 = value$1.customerName;
    let value$33 = value$1.deliveryNotes;
    let deliveryNotes = value$33.map(value => {
      let value$1 = value.status;
      let status = value$1 === "DRAFT" ? "DRAFT" : "PUBLISHED";
      let value$2 = value.date;
      let value$3 = Scalar.Datetime.serialize(value$2);
      let value$4 = value.name;
      let value$5 = value.id;
      let value$6 = value.__typename;
      return {
        __typename: value$6,
        id: value$5,
        name: value$4,
        date: value$3,
        status: status
      };
    });
    let value$34 = value$1.creditNotes;
    let creditNotes = value$34.map(value => {
      let value$1 = value.totalAmountIncludingTaxes;
      let value$2 = value.createdAt;
      let value$3 = Scalar.Datetime.serialize(value$2);
      let value$4 = value.name;
      let value$5 = value.id;
      let value$6 = value.__typename;
      return {
        __typename: value$6,
        id: value$5,
        name: value$4,
        createdAt: value$3,
        totalAmountIncludingTaxes: value$1
      };
    });
    let value$35 = value$1.salesReceipt;
    let salesReceipt;
    if (value$35 !== undefined) {
      let value$36 = value$35.createdAt;
      let value$37 = Scalar.Datetime.serialize(value$36);
      let value$38 = value$35.name;
      let value$39 = value$35.id;
      let value$40 = value$35.__typename;
      salesReceipt = {
        __typename: value$40,
        id: value$39,
        name: value$38,
        createdAt: value$37
      };
    } else {
      salesReceipt = null;
    }
    let value$41 = value$1.parentQuote;
    let parentQuote;
    if (value$41 !== undefined) {
      let value$42 = value$41.createdAt;
      let value$43 = Scalar.Datetime.serialize(value$42);
      let value$44 = value$41.name;
      let value$45 = value$41.id;
      let value$46 = value$41.__typename;
      parentQuote = {
        __typename: value$46,
        id: value$45,
        name: value$44,
        createdAt: value$43
      };
    } else {
      parentQuote = null;
    }
    let value$47 = value$1.name;
    let value$48 = value$1.id;
    let value$49 = value$1.__typename;
    let node = {
      __typename: value$49,
      id: value$48,
      name: value$47,
      parentQuote: parentQuote,
      salesReceipt: salesReceipt,
      creditNotes: creditNotes,
      deliveryNotes: deliveryNotes,
      customerName: value$32,
      customerAddress: customerAddress,
      customerCity: customerCity,
      customerPostalCode: customerPostalCode,
      customerCountry: customerCountry,
      customerEmail: customerEmail,
      customerIntraCommunityVAT: customerIntraCommunityVAT,
      customerPhoneNumber: customerPhoneNumber,
      customer: customer,
      issueDate: value$19,
      dueDate: dueDate,
      totalAmountIncludingTaxes: value$16,
      totalAmountExcludingTaxes: value$15,
      taxesIncluded: value$14,
      status: status,
      payments: payments,
      device: device,
      shop: shop,
      electronicInvoicingWorkflowState: electronicInvoicingWorkflowState
    };
    let value$50 = value.__typename;
    return {
      __typename: value$50,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let invoices = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    invoices: invoices
  };
}
function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectNullableInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => {
      if (b !== undefined) {
        return b;
      }
    })
  };
}
function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInputInvoicesQueryOrderBy(inp) {
  let a = inp.name;
  let a$1 = inp.issueDate;
  let a$2 = inp.totalAmountIncludingTaxes;
  return {
    name: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    issueDate: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeInputObjectInputInvoicesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.createdAt;
  let a$2 = inp.issueDate;
  let a$3 = inp.dueDate;
  let a$4 = inp.customerId;
  let a$5 = inp.status;
  let a$6 = inp.documentStatus;
  let a$7 = inp.paymentStatus;
  let a$8 = inp.paymentMethod;
  let a$9 = inp.deliveryStatus;
  let a$10 = inp.deviceIds;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter(a$1) : undefined,
    issueDate: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    dueDate: a$3 !== undefined ? serializeInputObjectDateFilter(a$3) : undefined,
    customerId: a$4 !== undefined ? serializeInputObjectNullableInFilter(a$4) : undefined,
    status: a$5 !== undefined ? serializeInputObjectInFilter(a$5) : undefined,
    documentStatus: a$6 !== undefined ? serializeInputObjectInFilter(a$6) : undefined,
    paymentStatus: a$7 !== undefined ? serializeInputObjectInFilter(a$7) : undefined,
    paymentMethod: a$8 !== undefined ? serializeInputObjectInFilter(a$8) : undefined,
    deliveryStatus: a$9 !== undefined ? serializeInputObjectInFilter(a$9) : undefined,
    deviceIds: a$10 !== undefined ? serializeInputObjectInFilter(a$10) : undefined
  };
}
function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputInvoicesQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputInvoicesQueryOrderBy) : undefined
  };
}
function makeVariables(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}
function makeInputObjectInputInvoicesQueryFilter(shopIds, createdAt, issueDate, dueDate, customerId, status, documentStatus, paymentStatus, paymentMethod, deliveryStatus, deviceIds, param) {
  return {
    shopIds: shopIds,
    createdAt: createdAt,
    issueDate: issueDate,
    dueDate: dueDate,
    customerId: customerId,
    status: status,
    documentStatus: documentStatus,
    paymentStatus: paymentStatus,
    paymentMethod: paymentMethod,
    deliveryStatus: deliveryStatus,
    deviceIds: deviceIds
  };
}
function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableInFilter(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectInputInvoicesQueryOrderBy(name, issueDate, totalAmountIncludingTaxes, param) {
  return {
    name: name,
    issueDate: issueDate,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes
  };
}
function makeDefaultVariables() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}
let SalesListInvoicesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputInvoicesQueryFilter: serializeInputObjectInputInvoicesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter,
  serializeInputObjectInputInvoicesQueryOrderBy: serializeInputObjectInputInvoicesQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputInvoicesQueryFilter: makeInputObjectInputInvoicesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter,
  makeInputObjectInputInvoicesQueryOrderBy: makeInputObjectInputInvoicesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let use = include.use;
let SalesListInvoicesQuery_refetchQueryDescription = include.refetchQueryDescription;
let SalesListInvoicesQuery_useLazy = include.useLazy;
let SalesListInvoicesQuery_useLazyWithVariables = include.useLazyWithVariables;
let SalesListInvoicesQuery = {
  SalesListInvoicesQuery_inner: SalesListInvoicesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputInvoicesQueryFilter: serializeInputObjectInputInvoicesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter,
  serializeInputObjectInputInvoicesQueryOrderBy: serializeInputObjectInputInvoicesQueryOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputInvoicesQueryFilter: makeInputObjectInputInvoicesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter,
  makeInputObjectInputInvoicesQueryOrderBy: makeInputObjectInputInvoicesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: SalesListInvoicesQuery_refetchQueryDescription,
  use: use,
  useLazy: SalesListInvoicesQuery_useLazy,
  useLazyWithVariables: SalesListInvoicesQuery_useLazyWithVariables
};
let Raw$1 = {};
let query$1 = Client.gql(["query SalesListSalesReceiptsQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputSalesReceiptsQueryFilter, $orderBy: [InputSalesReceiptsQueryOrderBy!])  {\nsalesReceipts(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \ninvoice  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\nrefundReceipts  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\ncustomer  {\n__typename  \nid  \nfirstName  \nlastName  \ncompanyName  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ncreatedAt  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntaxesIncluded  \npayments  {\n__typename  \nid  \nmethod  \namountReceived  \namountReturned  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$1(value) {
  let value$1 = value.salesReceipts;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    salesReceipts: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.invoice;
        let value$3 = value$1.refundReceipts;
        let value$4 = value$1.customer;
        let tmp;
        if (value$4 == null) {
          tmp = undefined;
        } else {
          let value$5 = value$4.firstName;
          let value$6 = value$4.lastName;
          let value$7 = value$4.companyName;
          let value$8 = value$4.kind;
          let tmp$1;
          switch (value$8) {
            case "BUSINESS":
              tmp$1 = "BUSINESS";
              break;
            case "CONSUMER":
              tmp$1 = "CONSUMER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = {
            __typename: value$4.__typename,
            id: value$4.id,
            firstName: !(value$5 == null) ? value$5 : undefined,
            lastName: !(value$6 == null) ? value$6 : undefined,
            companyName: !(value$7 == null) ? value$7 : undefined,
            kind: tmp$1,
            hasSubscribedToLoyaltyProgram: value$4.hasSubscribedToLoyaltyProgram
          };
        }
        let value$9 = value$1.payments;
        let value$10 = value$1.device;
        let value$11 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            invoice: !(value$2 == null) ? {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              createdAt: Scalar.Datetime.parse(value$2.createdAt)
            } : undefined,
            refundReceipts: value$3.map(value => ({
              __typename: value.__typename,
              id: value.id,
              name: value.name,
              createdAt: Scalar.Datetime.parse(value.createdAt)
            })),
            customer: tmp,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            taxesIncluded: value$1.taxesIncluded,
            payments: value$9.map(value => {
              let value$1 = value.method;
              let tmp;
              switch (value$1) {
                case "AMEX":
                  tmp = "AMEX";
                  break;
                case "BANK_TRANSFER":
                  tmp = "BANK_TRANSFER";
                  break;
                case "BARNABY":
                  tmp = "BARNABY";
                  break;
                case "CASH":
                  tmp = "CASH";
                  break;
                case "CHEQUE":
                  tmp = "CHEQUE";
                  break;
                case "CONTACTLESS_AMEX":
                  tmp = "CONTACTLESS_AMEX";
                  break;
                case "CONTACTLESS_DEBIT_CARD":
                  tmp = "CONTACTLESS_DEBIT_CARD";
                  break;
                case "CREDIT_MEMO":
                  tmp = "CREDIT_MEMO";
                  break;
                case "DEBIT_CARD":
                  tmp = "DEBIT_CARD";
                  break;
                case "DISTANCE_SELLING":
                  tmp = "DISTANCE_SELLING";
                  break;
                case "EUSKO_CASH":
                  tmp = "EUSKO_CASH";
                  break;
                case "EUSKO_DIGITAL":
                  tmp = "EUSKO_DIGITAL";
                  break;
                case "GIFT_VOUCHER":
                  tmp = "GIFT_VOUCHER";
                  break;
                case "LESHABITUES":
                  tmp = "LESHABITUES";
                  break;
                case "LYDIA":
                  tmp = "LYDIA";
                  break;
                case "PAYPAL":
                  tmp = "PAYPAL";
                  break;
                case "TICKET_RESTAURANT":
                  tmp = "TICKET_RESTAURANT";
                  break;
                case "TOWN_HALL_GIFT_VOUCHER":
                  tmp = "TOWN_HALL_GIFT_VOUCHER";
                  break;
                case "WINO_PAY":
                  tmp = "WINO_PAY";
                  break;
                default:
                  throw {
                    RE_EXN_ID: "Not_found",
                    Error: new Error()
                  };
              }
              return {
                __typename: value.__typename,
                id: value.id,
                method: tmp,
                amountReceived: value.amountReceived,
                amountReturned: value.amountReturned
              };
            }),
            device: {
              __typename: value$10.__typename,
              id: value$10.id,
              name: value$10.name,
              slug: value$10.slug
            },
            shop: {
              __typename: value$11.__typename,
              id: value$11.id,
              name: value$11.name
            }
          }
        };
      })
    }
  };
}
function serialize$1(value) {
  let value$1 = value.salesReceipts;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.name;
    let value$4 = value$2.id;
    let value$5 = value$2.__typename;
    let shop = {
      __typename: value$5,
      id: value$4,
      name: value$3
    };
    let value$6 = value$1.device;
    let value$7 = value$6.slug;
    let value$8 = value$6.name;
    let value$9 = value$6.id;
    let value$10 = value$6.__typename;
    let device = {
      __typename: value$10,
      id: value$9,
      name: value$8,
      slug: value$7
    };
    let value$11 = value$1.payments;
    let payments = value$11.map(value => {
      let value$1 = value.amountReturned;
      let value$2 = value.amountReceived;
      let value$3 = value.method;
      let method_ = value$3 === "LESHABITUES" ? "LESHABITUES" : value$3 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$3 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$3 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$3 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$3 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$3 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$3 === "CHEQUE" ? "CHEQUE" : value$3 === "LYDIA" ? "LYDIA" : value$3 === "DEBIT_CARD" ? "DEBIT_CARD" : value$3 === "EUSKO_CASH" ? "EUSKO_CASH" : value$3 === "BARNABY" ? "BARNABY" : value$3 === "PAYPAL" ? "PAYPAL" : value$3 === "AMEX" ? "AMEX" : value$3 === "CASH" ? "CASH" : value$3 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$3 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$3 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
      let value$4 = value.id;
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        id: value$4,
        method: method_,
        amountReceived: value$2,
        amountReturned: value$1
      };
    });
    let value$12 = value$1.taxesIncluded;
    let value$13 = value$1.totalAmountExcludingTaxes;
    let value$14 = value$1.totalAmountIncludingTaxes;
    let value$15 = value$1.createdAt;
    let value$16 = Scalar.Datetime.serialize(value$15);
    let value$17 = value$1.customer;
    let customer;
    if (value$17 !== undefined) {
      let value$18 = value$17.hasSubscribedToLoyaltyProgram;
      let value$19 = value$17.kind;
      let kind = value$19 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
      let value$20 = value$17.companyName;
      let companyName = value$20 !== undefined ? value$20 : null;
      let value$21 = value$17.lastName;
      let lastName = value$21 !== undefined ? value$21 : null;
      let value$22 = value$17.firstName;
      let firstName = value$22 !== undefined ? value$22 : null;
      let value$23 = value$17.id;
      let value$24 = value$17.__typename;
      customer = {
        __typename: value$24,
        id: value$23,
        firstName: firstName,
        lastName: lastName,
        companyName: companyName,
        kind: kind,
        hasSubscribedToLoyaltyProgram: value$18
      };
    } else {
      customer = null;
    }
    let value$25 = value$1.refundReceipts;
    let refundReceipts = value$25.map(value => {
      let value$1 = value.createdAt;
      let value$2 = Scalar.Datetime.serialize(value$1);
      let value$3 = value.name;
      let value$4 = value.id;
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        id: value$4,
        name: value$3,
        createdAt: value$2
      };
    });
    let value$26 = value$1.invoice;
    let invoice;
    if (value$26 !== undefined) {
      let value$27 = value$26.createdAt;
      let value$28 = Scalar.Datetime.serialize(value$27);
      let value$29 = value$26.name;
      let value$30 = value$26.id;
      let value$31 = value$26.__typename;
      invoice = {
        __typename: value$31,
        id: value$30,
        name: value$29,
        createdAt: value$28
      };
    } else {
      invoice = null;
    }
    let value$32 = value$1.name;
    let value$33 = value$1.id;
    let value$34 = value$1.__typename;
    let node = {
      __typename: value$34,
      id: value$33,
      name: value$32,
      invoice: invoice,
      refundReceipts: refundReceipts,
      customer: customer,
      createdAt: value$16,
      totalAmountIncludingTaxes: value$14,
      totalAmountExcludingTaxes: value$13,
      taxesIncluded: value$12,
      payments: payments,
      device: device,
      shop: shop
    };
    let value$35 = value.__typename;
    return {
      __typename: value$35,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let salesReceipts = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    salesReceipts: salesReceipts
  };
}
function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectDateFilter$1(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectNullableInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => {
      if (b !== undefined) {
        return b;
      }
    })
  };
}
function serializeInputObjectInputSalesReceiptsQueryOrderBy(inp) {
  let a = inp.name;
  let a$1 = inp.createdAt;
  let a$2 = inp.totalAmountIncludingTaxes;
  return {
    name: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    createdAt: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeInputObjectInputSalesReceiptsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.createdAt;
  let a$2 = inp.customerId;
  let a$3 = inp.paymentStatus;
  let a$4 = inp.paymentMethod;
  let a$5 = inp.deviceIds;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$1(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter$1(a$1) : undefined,
    customerId: a$2 !== undefined ? serializeInputObjectNullableInFilter$1(a$2) : undefined,
    paymentStatus: a$3 !== undefined ? serializeInputObjectInFilter$1(a$3) : undefined,
    paymentMethod: a$4 !== undefined ? serializeInputObjectInFilter$1(a$4) : undefined,
    deviceIds: a$5 !== undefined ? serializeInputObjectInFilter$1(a$5) : undefined
  };
}
function serializeVariables$1(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputSalesReceiptsQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputSalesReceiptsQueryOrderBy) : undefined
  };
}
function makeVariables$1(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}
function makeInputObjectInputSalesReceiptsQueryFilter(shopIds, createdAt, customerId, paymentStatus, paymentMethod, deviceIds, param) {
  return {
    shopIds: shopIds,
    createdAt: createdAt,
    customerId: customerId,
    paymentStatus: paymentStatus,
    paymentMethod: paymentMethod,
    deviceIds: deviceIds
  };
}
function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter$1(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableInFilter$1(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectInputSalesReceiptsQueryOrderBy(name, createdAt, totalAmountIncludingTaxes, param) {
  return {
    name: name,
    createdAt: createdAt,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes
  };
}
function makeDefaultVariables$1() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}
let SalesListSalesReceiptsQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputSalesReceiptsQueryFilter: serializeInputObjectInputSalesReceiptsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$1,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$1,
  serializeInputObjectInputSalesReceiptsQueryOrderBy: serializeInputObjectInputSalesReceiptsQueryOrderBy,
  makeVariables: makeVariables$1,
  makeInputObjectInputSalesReceiptsQueryFilter: makeInputObjectInputSalesReceiptsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter$1,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$1,
  makeInputObjectInputSalesReceiptsQueryOrderBy: makeInputObjectInputSalesReceiptsQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$1
};
let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});
let use$1 = include$1.use;
let SalesListSalesReceiptsQuery_refetchQueryDescription = include$1.refetchQueryDescription;
let SalesListSalesReceiptsQuery_useLazy = include$1.useLazy;
let SalesListSalesReceiptsQuery_useLazyWithVariables = include$1.useLazyWithVariables;
let SalesListSalesReceiptsQuery = {
  SalesListSalesReceiptsQuery_inner: SalesListSalesReceiptsQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputSalesReceiptsQueryFilter: serializeInputObjectInputSalesReceiptsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$1,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$1,
  serializeInputObjectInputSalesReceiptsQueryOrderBy: serializeInputObjectInputSalesReceiptsQueryOrderBy,
  makeVariables: makeVariables$1,
  makeInputObjectInputSalesReceiptsQueryFilter: makeInputObjectInputSalesReceiptsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter$1,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$1,
  makeInputObjectInputSalesReceiptsQueryOrderBy: makeInputObjectInputSalesReceiptsQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: SalesListSalesReceiptsQuery_refetchQueryDescription,
  use: use$1,
  useLazy: SalesListSalesReceiptsQuery_useLazy,
  useLazyWithVariables: SalesListSalesReceiptsQuery_useLazyWithVariables
};
let Raw$2 = {};
let query$2 = Client.gql(["query SalesListCreditNotesQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputCreditNotesQueryFilter, $orderBy: [InputCreditNotesQueryOrderBy!])  {\ncreditNotes(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nparentInvoice  {\n__typename  \nid  \nname  \nissueDate  \n}\n\ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ncreatedAt  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntaxesIncluded  \ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$2(value) {
  let value$1 = value.creditNotes;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    creditNotes: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.parentInvoice;
        let value$3 = value$1.customerAddress;
        let value$4 = value$1.customerCity;
        let value$5 = value$1.customerPostalCode;
        let value$6 = value$1.customerCountry;
        let value$7 = value$1.customerEmail;
        let value$8 = value$1.customerIntraCommunityVAT;
        let value$9 = value$1.customerPhoneNumber;
        let value$10 = value$1.customer;
        let tmp;
        if (value$10 == null) {
          tmp = undefined;
        } else {
          let value$11 = value$10.kind;
          let tmp$1;
          switch (value$11) {
            case "BUSINESS":
              tmp$1 = "BUSINESS";
              break;
            case "CONSUMER":
              tmp$1 = "CONSUMER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = {
            __typename: value$10.__typename,
            id: value$10.id,
            kind: tmp$1,
            hasSubscribedToLoyaltyProgram: value$10.hasSubscribedToLoyaltyProgram
          };
        }
        let value$12 = value$1.device;
        let value$13 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            parentInvoice: !(value$2 == null) ? {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              issueDate: Scalar.Datetime.parse(value$2.issueDate)
            } : undefined,
            customerName: value$1.customerName,
            customerAddress: !(value$3 == null) ? value$3 : undefined,
            customerCity: !(value$4 == null) ? value$4 : undefined,
            customerPostalCode: !(value$5 == null) ? value$5 : undefined,
            customerCountry: !(value$6 == null) ? value$6 : undefined,
            customerEmail: !(value$7 == null) ? value$7 : undefined,
            customerIntraCommunityVAT: !(value$8 == null) ? value$8 : undefined,
            customerPhoneNumber: !(value$9 == null) ? value$9 : undefined,
            customer: tmp,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            taxesIncluded: value$1.taxesIncluded,
            device: {
              __typename: value$12.__typename,
              id: value$12.id,
              name: value$12.name,
              slug: value$12.slug
            },
            shop: {
              __typename: value$13.__typename,
              id: value$13.id,
              name: value$13.name
            }
          }
        };
      })
    }
  };
}
function serialize$2(value) {
  let value$1 = value.creditNotes;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.name;
    let value$4 = value$2.id;
    let value$5 = value$2.__typename;
    let shop = {
      __typename: value$5,
      id: value$4,
      name: value$3
    };
    let value$6 = value$1.device;
    let value$7 = value$6.slug;
    let value$8 = value$6.name;
    let value$9 = value$6.id;
    let value$10 = value$6.__typename;
    let device = {
      __typename: value$10,
      id: value$9,
      name: value$8,
      slug: value$7
    };
    let value$11 = value$1.taxesIncluded;
    let value$12 = value$1.totalAmountExcludingTaxes;
    let value$13 = value$1.totalAmountIncludingTaxes;
    let value$14 = value$1.createdAt;
    let value$15 = Scalar.Datetime.serialize(value$14);
    let value$16 = value$1.customer;
    let customer;
    if (value$16 !== undefined) {
      let value$17 = value$16.hasSubscribedToLoyaltyProgram;
      let value$18 = value$16.kind;
      let kind = value$18 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
      let value$19 = value$16.id;
      let value$20 = value$16.__typename;
      customer = {
        __typename: value$20,
        id: value$19,
        kind: kind,
        hasSubscribedToLoyaltyProgram: value$17
      };
    } else {
      customer = null;
    }
    let value$21 = value$1.customerPhoneNumber;
    let customerPhoneNumber = value$21 !== undefined ? value$21 : null;
    let value$22 = value$1.customerIntraCommunityVAT;
    let customerIntraCommunityVAT = value$22 !== undefined ? value$22 : null;
    let value$23 = value$1.customerEmail;
    let customerEmail = value$23 !== undefined ? value$23 : null;
    let value$24 = value$1.customerCountry;
    let customerCountry = value$24 !== undefined ? value$24 : null;
    let value$25 = value$1.customerPostalCode;
    let customerPostalCode = value$25 !== undefined ? value$25 : null;
    let value$26 = value$1.customerCity;
    let customerCity = value$26 !== undefined ? value$26 : null;
    let value$27 = value$1.customerAddress;
    let customerAddress = value$27 !== undefined ? value$27 : null;
    let value$28 = value$1.customerName;
    let value$29 = value$1.parentInvoice;
    let parentInvoice;
    if (value$29 !== undefined) {
      let value$30 = value$29.issueDate;
      let value$31 = Scalar.Datetime.serialize(value$30);
      let value$32 = value$29.name;
      let value$33 = value$29.id;
      let value$34 = value$29.__typename;
      parentInvoice = {
        __typename: value$34,
        id: value$33,
        name: value$32,
        issueDate: value$31
      };
    } else {
      parentInvoice = null;
    }
    let value$35 = value$1.name;
    let value$36 = value$1.id;
    let value$37 = value$1.__typename;
    let node = {
      __typename: value$37,
      id: value$36,
      name: value$35,
      parentInvoice: parentInvoice,
      customerName: value$28,
      customerAddress: customerAddress,
      customerCity: customerCity,
      customerPostalCode: customerPostalCode,
      customerCountry: customerCountry,
      customerEmail: customerEmail,
      customerIntraCommunityVAT: customerIntraCommunityVAT,
      customerPhoneNumber: customerPhoneNumber,
      customer: customer,
      createdAt: value$15,
      totalAmountIncludingTaxes: value$13,
      totalAmountExcludingTaxes: value$12,
      taxesIncluded: value$11,
      device: device,
      shop: shop
    };
    let value$38 = value.__typename;
    return {
      __typename: value$38,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let creditNotes = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    creditNotes: creditNotes
  };
}
function serializeInputObjectDateFilter$2(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInFilter$2(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectNullableInFilter$2(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => {
      if (b !== undefined) {
        return b;
      }
    })
  };
}
function serializeInputObjectInputCreditNotesQueryOrderBy(inp) {
  let a = inp.name;
  let a$1 = inp.createdAt;
  let a$2 = inp.totalAmountIncludingTaxes;
  return {
    name: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    createdAt: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeInputObjectInputCreditNotesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.createdAt;
  let a$2 = inp.customerId;
  let a$3 = inp.deviceIds;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$2(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter$2(a$1) : undefined,
    customerId: a$2 !== undefined ? serializeInputObjectNullableInFilter$2(a$2) : undefined,
    deviceIds: a$3 !== undefined ? serializeInputObjectInFilter$2(a$3) : undefined
  };
}
function serializeVariables$2(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputCreditNotesQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputCreditNotesQueryOrderBy) : undefined
  };
}
function makeVariables$2(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}
function makeInputObjectInputCreditNotesQueryFilter(shopIds, createdAt, customerId, deviceIds, param) {
  return {
    shopIds: shopIds,
    createdAt: createdAt,
    customerId: customerId,
    deviceIds: deviceIds
  };
}
function makeInputObjectInFilter$2(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter$2(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableInFilter$2(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectInputCreditNotesQueryOrderBy(name, createdAt, totalAmountIncludingTaxes, param) {
  return {
    name: name,
    createdAt: createdAt,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes
  };
}
function makeDefaultVariables$2() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}
let SalesListCreditNotesQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputCreditNotesQueryFilter: serializeInputObjectInputCreditNotesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$2,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$2,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$2,
  serializeInputObjectInputCreditNotesQueryOrderBy: serializeInputObjectInputCreditNotesQueryOrderBy,
  makeVariables: makeVariables$2,
  makeInputObjectInputCreditNotesQueryFilter: makeInputObjectInputCreditNotesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$2,
  makeInputObjectDateFilter: makeInputObjectDateFilter$2,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$2,
  makeInputObjectInputCreditNotesQueryOrderBy: makeInputObjectInputCreditNotesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$2
};
let include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});
let use$2 = include$2.use;
let SalesListCreditNotesQuery_refetchQueryDescription = include$2.refetchQueryDescription;
let SalesListCreditNotesQuery_useLazy = include$2.useLazy;
let SalesListCreditNotesQuery_useLazyWithVariables = include$2.useLazyWithVariables;
let SalesListCreditNotesQuery = {
  SalesListCreditNotesQuery_inner: SalesListCreditNotesQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputCreditNotesQueryFilter: serializeInputObjectInputCreditNotesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$2,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$2,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$2,
  serializeInputObjectInputCreditNotesQueryOrderBy: serializeInputObjectInputCreditNotesQueryOrderBy,
  makeVariables: makeVariables$2,
  makeInputObjectInputCreditNotesQueryFilter: makeInputObjectInputCreditNotesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$2,
  makeInputObjectDateFilter: makeInputObjectDateFilter$2,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$2,
  makeInputObjectInputCreditNotesQueryOrderBy: makeInputObjectInputCreditNotesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$2,
  refetchQueryDescription: SalesListCreditNotesQuery_refetchQueryDescription,
  use: use$2,
  useLazy: SalesListCreditNotesQuery_useLazy,
  useLazyWithVariables: SalesListCreditNotesQuery_useLazyWithVariables
};
let Raw$3 = {};
let query$3 = Client.gql(["query SalesListRefundReceiptsQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputRefundReceiptsQueryFilter, $orderBy: [InputRefundReceiptsQueryOrderBy!])  {\nrefundReceipts(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nreason  \nsalesReceipt  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\ncustomer  {\n__typename  \nid  \nfirstName  \nlastName  \ncompanyName  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ncreatedAt  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntotalAmountOfTaxes  \npayments  {\n__typename  \nid  \nmethod  \namountReceived  \namountReturned  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$3(value) {
  let value$1 = value.refundReceipts;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    refundReceipts: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.reason;
        let tmp;
        switch (value$2) {
          case "CANCELLATION_SALE":
            tmp = "CANCELLATION_SALE";
            break;
          case "CASHING_ERROR":
            tmp = "CASHING_ERROR";
            break;
          case "OTHER_REASON":
            tmp = "OTHER_REASON";
            break;
          case "PRODUCT_NOT_COMPLIANT_OR_DAMAGED":
            tmp = "PRODUCT_NOT_COMPLIANT_OR_DAMAGED";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$3 = value$1.salesReceipt;
        let value$4 = value$1.customer;
        let tmp$1;
        if (value$4 == null) {
          tmp$1 = undefined;
        } else {
          let value$5 = value$4.firstName;
          let value$6 = value$4.lastName;
          let value$7 = value$4.companyName;
          let value$8 = value$4.kind;
          let tmp$2;
          switch (value$8) {
            case "BUSINESS":
              tmp$2 = "BUSINESS";
              break;
            case "CONSUMER":
              tmp$2 = "CONSUMER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = {
            __typename: value$4.__typename,
            id: value$4.id,
            firstName: !(value$5 == null) ? value$5 : undefined,
            lastName: !(value$6 == null) ? value$6 : undefined,
            companyName: !(value$7 == null) ? value$7 : undefined,
            kind: tmp$2,
            hasSubscribedToLoyaltyProgram: value$4.hasSubscribedToLoyaltyProgram
          };
        }
        let value$9 = value$1.payments;
        let value$10 = value$1.device;
        let value$11 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            reason: tmp,
            salesReceipt: {
              __typename: value$3.__typename,
              id: value$3.id,
              name: value$3.name,
              createdAt: Scalar.Datetime.parse(value$3.createdAt)
            },
            customer: tmp$1,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            totalAmountOfTaxes: value$1.totalAmountOfTaxes,
            payments: value$9.map(value => {
              let value$1 = value.method;
              let tmp;
              switch (value$1) {
                case "AMEX":
                  tmp = "AMEX";
                  break;
                case "BANK_TRANSFER":
                  tmp = "BANK_TRANSFER";
                  break;
                case "BARNABY":
                  tmp = "BARNABY";
                  break;
                case "CASH":
                  tmp = "CASH";
                  break;
                case "CHEQUE":
                  tmp = "CHEQUE";
                  break;
                case "CONTACTLESS_AMEX":
                  tmp = "CONTACTLESS_AMEX";
                  break;
                case "CONTACTLESS_DEBIT_CARD":
                  tmp = "CONTACTLESS_DEBIT_CARD";
                  break;
                case "CREDIT_MEMO":
                  tmp = "CREDIT_MEMO";
                  break;
                case "DEBIT_CARD":
                  tmp = "DEBIT_CARD";
                  break;
                case "DISTANCE_SELLING":
                  tmp = "DISTANCE_SELLING";
                  break;
                case "EUSKO_CASH":
                  tmp = "EUSKO_CASH";
                  break;
                case "EUSKO_DIGITAL":
                  tmp = "EUSKO_DIGITAL";
                  break;
                case "GIFT_VOUCHER":
                  tmp = "GIFT_VOUCHER";
                  break;
                case "LESHABITUES":
                  tmp = "LESHABITUES";
                  break;
                case "LYDIA":
                  tmp = "LYDIA";
                  break;
                case "PAYPAL":
                  tmp = "PAYPAL";
                  break;
                case "TICKET_RESTAURANT":
                  tmp = "TICKET_RESTAURANT";
                  break;
                case "TOWN_HALL_GIFT_VOUCHER":
                  tmp = "TOWN_HALL_GIFT_VOUCHER";
                  break;
                case "WINO_PAY":
                  tmp = "WINO_PAY";
                  break;
                default:
                  throw {
                    RE_EXN_ID: "Not_found",
                    Error: new Error()
                  };
              }
              return {
                __typename: value.__typename,
                id: value.id,
                method: tmp,
                amountReceived: value.amountReceived,
                amountReturned: value.amountReturned
              };
            }),
            device: {
              __typename: value$10.__typename,
              id: value$10.id,
              name: value$10.name,
              slug: value$10.slug
            },
            shop: {
              __typename: value$11.__typename,
              id: value$11.id,
              name: value$11.name
            }
          }
        };
      })
    }
  };
}
function serialize$3(value) {
  let value$1 = value.refundReceipts;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.name;
    let value$4 = value$2.id;
    let value$5 = value$2.__typename;
    let shop = {
      __typename: value$5,
      id: value$4,
      name: value$3
    };
    let value$6 = value$1.device;
    let value$7 = value$6.slug;
    let value$8 = value$6.name;
    let value$9 = value$6.id;
    let value$10 = value$6.__typename;
    let device = {
      __typename: value$10,
      id: value$9,
      name: value$8,
      slug: value$7
    };
    let value$11 = value$1.payments;
    let payments = value$11.map(value => {
      let value$1 = value.amountReturned;
      let value$2 = value.amountReceived;
      let value$3 = value.method;
      let method_ = value$3 === "LESHABITUES" ? "LESHABITUES" : value$3 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$3 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$3 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$3 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$3 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$3 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$3 === "CHEQUE" ? "CHEQUE" : value$3 === "LYDIA" ? "LYDIA" : value$3 === "DEBIT_CARD" ? "DEBIT_CARD" : value$3 === "EUSKO_CASH" ? "EUSKO_CASH" : value$3 === "BARNABY" ? "BARNABY" : value$3 === "PAYPAL" ? "PAYPAL" : value$3 === "AMEX" ? "AMEX" : value$3 === "CASH" ? "CASH" : value$3 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$3 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$3 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
      let value$4 = value.id;
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        id: value$4,
        method: method_,
        amountReceived: value$2,
        amountReturned: value$1
      };
    });
    let value$12 = value$1.totalAmountOfTaxes;
    let value$13 = value$1.totalAmountExcludingTaxes;
    let value$14 = value$1.totalAmountIncludingTaxes;
    let value$15 = value$1.createdAt;
    let value$16 = Scalar.Datetime.serialize(value$15);
    let value$17 = value$1.customer;
    let customer;
    if (value$17 !== undefined) {
      let value$18 = value$17.hasSubscribedToLoyaltyProgram;
      let value$19 = value$17.kind;
      let kind = value$19 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
      let value$20 = value$17.companyName;
      let companyName = value$20 !== undefined ? value$20 : null;
      let value$21 = value$17.lastName;
      let lastName = value$21 !== undefined ? value$21 : null;
      let value$22 = value$17.firstName;
      let firstName = value$22 !== undefined ? value$22 : null;
      let value$23 = value$17.id;
      let value$24 = value$17.__typename;
      customer = {
        __typename: value$24,
        id: value$23,
        firstName: firstName,
        lastName: lastName,
        companyName: companyName,
        kind: kind,
        hasSubscribedToLoyaltyProgram: value$18
      };
    } else {
      customer = null;
    }
    let value$25 = value$1.salesReceipt;
    let value$26 = value$25.createdAt;
    let value$27 = Scalar.Datetime.serialize(value$26);
    let value$28 = value$25.name;
    let value$29 = value$25.id;
    let value$30 = value$25.__typename;
    let salesReceipt = {
      __typename: value$30,
      id: value$29,
      name: value$28,
      createdAt: value$27
    };
    let value$31 = value$1.reason;
    let reason = value$31 === "OTHER_REASON" ? "OTHER_REASON" : value$31 === "PRODUCT_NOT_COMPLIANT_OR_DAMAGED" ? "PRODUCT_NOT_COMPLIANT_OR_DAMAGED" : value$31 === "CANCELLATION_SALE" ? "CANCELLATION_SALE" : "CASHING_ERROR";
    let value$32 = value$1.name;
    let value$33 = value$1.id;
    let value$34 = value$1.__typename;
    let node = {
      __typename: value$34,
      id: value$33,
      name: value$32,
      reason: reason,
      salesReceipt: salesReceipt,
      customer: customer,
      createdAt: value$16,
      totalAmountIncludingTaxes: value$14,
      totalAmountExcludingTaxes: value$13,
      totalAmountOfTaxes: value$12,
      payments: payments,
      device: device,
      shop: shop
    };
    let value$35 = value.__typename;
    return {
      __typename: value$35,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let refundReceipts = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    refundReceipts: refundReceipts
  };
}
function serializeInputObjectDateFilter$3(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectNullableInFilter$3(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => {
      if (b !== undefined) {
        return b;
      }
    })
  };
}
function serializeInputObjectInFilter$3(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectInputRefundReceiptsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.createdAt;
  let a$2 = inp.customerId;
  let a$3 = inp.paymentMethod;
  let a$4 = inp.deviceIds;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$3(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter$3(a$1) : undefined,
    customerId: a$2 !== undefined ? serializeInputObjectNullableInFilter$3(a$2) : undefined,
    paymentMethod: a$3 !== undefined ? serializeInputObjectInFilter$3(a$3) : undefined,
    deviceIds: a$4 !== undefined ? serializeInputObjectInFilter$3(a$4) : undefined
  };
}
function serializeInputObjectInputRefundReceiptsQueryOrderBy(inp) {
  let a = inp.name;
  let a$1 = inp.createdAt;
  let a$2 = inp.totalAmountIncludingTaxes;
  return {
    name: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    createdAt: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeVariables$3(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputRefundReceiptsQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputRefundReceiptsQueryOrderBy) : undefined
  };
}
function makeVariables$3(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}
function makeInputObjectInputRefundReceiptsQueryFilter(shopIds, createdAt, customerId, paymentMethod, deviceIds, param) {
  return {
    shopIds: shopIds,
    createdAt: createdAt,
    customerId: customerId,
    paymentMethod: paymentMethod,
    deviceIds: deviceIds
  };
}
function makeInputObjectInFilter$3(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter$3(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableInFilter$3(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectInputRefundReceiptsQueryOrderBy(name, createdAt, totalAmountIncludingTaxes, param) {
  return {
    name: name,
    createdAt: createdAt,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes
  };
}
function makeDefaultVariables$3() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}
let SalesListRefundReceiptsQuery_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  serializeInputObjectInputRefundReceiptsQueryFilter: serializeInputObjectInputRefundReceiptsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$3,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$3,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$3,
  serializeInputObjectInputRefundReceiptsQueryOrderBy: serializeInputObjectInputRefundReceiptsQueryOrderBy,
  makeVariables: makeVariables$3,
  makeInputObjectInputRefundReceiptsQueryFilter: makeInputObjectInputRefundReceiptsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$3,
  makeInputObjectDateFilter: makeInputObjectDateFilter$3,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$3,
  makeInputObjectInputRefundReceiptsQueryOrderBy: makeInputObjectInputRefundReceiptsQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$3
};
let include$3 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$3,
  Raw: Raw$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3
});
let use$3 = include$3.use;
let SalesListRefundReceiptsQuery_refetchQueryDescription = include$3.refetchQueryDescription;
let SalesListRefundReceiptsQuery_useLazy = include$3.useLazy;
let SalesListRefundReceiptsQuery_useLazyWithVariables = include$3.useLazyWithVariables;
let SalesListRefundReceiptsQuery = {
  SalesListRefundReceiptsQuery_inner: SalesListRefundReceiptsQuery_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables$3,
  serializeInputObjectInputRefundReceiptsQueryFilter: serializeInputObjectInputRefundReceiptsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$3,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$3,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$3,
  serializeInputObjectInputRefundReceiptsQueryOrderBy: serializeInputObjectInputRefundReceiptsQueryOrderBy,
  makeVariables: makeVariables$3,
  makeInputObjectInputRefundReceiptsQueryFilter: makeInputObjectInputRefundReceiptsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$3,
  makeInputObjectDateFilter: makeInputObjectDateFilter$3,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$3,
  makeInputObjectInputRefundReceiptsQueryOrderBy: makeInputObjectInputRefundReceiptsQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$3,
  refetchQueryDescription: SalesListRefundReceiptsQuery_refetchQueryDescription,
  use: use$3,
  useLazy: SalesListRefundReceiptsQuery_useLazy,
  useLazyWithVariables: SalesListRefundReceiptsQuery_useLazyWithVariables
};
let Raw$4 = {};
let query$4 = Client.gql(["query SalesListDeliveryNotesQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputDeliveryNotesQueryFilter, $orderBy: [InputDeliveryNotesQueryOrderBy!])  {\ndeliveryNotes(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ncreatedAt  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntaxesIncluded  \nstatus  \ninvoices  {\n__typename  \nid  \narchivedAt  \nname  \nissueDate  \nstatus  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$4(value) {
  let value$1 = value.deliveryNotes;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    deliveryNotes: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.customerAddress;
        let value$3 = value$1.customerCity;
        let value$4 = value$1.customerPostalCode;
        let value$5 = value$1.customerCountry;
        let value$6 = value$1.customerEmail;
        let value$7 = value$1.customerIntraCommunityVAT;
        let value$8 = value$1.customerPhoneNumber;
        let value$9 = value$1.customer;
        let tmp;
        if (value$9 == null) {
          tmp = undefined;
        } else {
          let value$10 = value$9.kind;
          let tmp$1;
          switch (value$10) {
            case "BUSINESS":
              tmp$1 = "BUSINESS";
              break;
            case "CONSUMER":
              tmp$1 = "CONSUMER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = {
            __typename: value$9.__typename,
            id: value$9.id,
            kind: tmp$1,
            hasSubscribedToLoyaltyProgram: value$9.hasSubscribedToLoyaltyProgram
          };
        }
        let value$11 = value$1.status;
        let tmp$2;
        switch (value$11) {
          case "DRAFT":
            tmp$2 = "DRAFT";
            break;
          case "PUBLISHED":
            tmp$2 = "PUBLISHED";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$12 = value$1.invoices;
        let value$13 = value$1.device;
        let value$14 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            customerName: value$1.customerName,
            customerAddress: !(value$2 == null) ? value$2 : undefined,
            customerCity: !(value$3 == null) ? value$3 : undefined,
            customerPostalCode: !(value$4 == null) ? value$4 : undefined,
            customerCountry: !(value$5 == null) ? value$5 : undefined,
            customerEmail: !(value$6 == null) ? value$6 : undefined,
            customerIntraCommunityVAT: !(value$7 == null) ? value$7 : undefined,
            customerPhoneNumber: !(value$8 == null) ? value$8 : undefined,
            customer: tmp,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            taxesIncluded: value$1.taxesIncluded,
            status: tmp$2,
            invoices: value$12.map(value => {
              let value$1 = value.archivedAt;
              let value$2 = value.status;
              let tmp;
              switch (value$2) {
                case "DRAFT":
                  tmp = "DRAFT";
                  break;
                case "PAID":
                  tmp = "PAID";
                  break;
                case "UNPAID":
                  tmp = "UNPAID";
                  break;
                default:
                  throw {
                    RE_EXN_ID: "Not_found",
                    Error: new Error()
                  };
              }
              return {
                __typename: value.__typename,
                id: value.id,
                archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
                name: value.name,
                issueDate: Scalar.Datetime.parse(value.issueDate),
                status: tmp
              };
            }),
            device: {
              __typename: value$13.__typename,
              id: value$13.id,
              name: value$13.name,
              slug: value$13.slug
            },
            shop: {
              __typename: value$14.__typename,
              id: value$14.id,
              name: value$14.name
            }
          }
        };
      })
    }
  };
}
function serialize$4(value) {
  let value$1 = value.deliveryNotes;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.name;
    let value$4 = value$2.id;
    let value$5 = value$2.__typename;
    let shop = {
      __typename: value$5,
      id: value$4,
      name: value$3
    };
    let value$6 = value$1.device;
    let value$7 = value$6.slug;
    let value$8 = value$6.name;
    let value$9 = value$6.id;
    let value$10 = value$6.__typename;
    let device = {
      __typename: value$10,
      id: value$9,
      name: value$8,
      slug: value$7
    };
    let value$11 = value$1.invoices;
    let invoices = value$11.map(value => {
      let value$1 = value.status;
      let status = value$1 === "UNPAID" ? "UNPAID" : value$1 === "PAID" ? "PAID" : "DRAFT";
      let value$2 = value.issueDate;
      let value$3 = Scalar.Datetime.serialize(value$2);
      let value$4 = value.name;
      let value$5 = value.archivedAt;
      let archivedAt = value$5 !== undefined ? Scalar.Datetime.serialize(value$5) : null;
      let value$6 = value.id;
      let value$7 = value.__typename;
      return {
        __typename: value$7,
        id: value$6,
        archivedAt: archivedAt,
        name: value$4,
        issueDate: value$3,
        status: status
      };
    });
    let value$12 = value$1.status;
    let status = value$12 === "DRAFT" ? "DRAFT" : "PUBLISHED";
    let value$13 = value$1.taxesIncluded;
    let value$14 = value$1.totalAmountExcludingTaxes;
    let value$15 = value$1.totalAmountIncludingTaxes;
    let value$16 = value$1.createdAt;
    let value$17 = Scalar.Datetime.serialize(value$16);
    let value$18 = value$1.customer;
    let customer;
    if (value$18 !== undefined) {
      let value$19 = value$18.hasSubscribedToLoyaltyProgram;
      let value$20 = value$18.kind;
      let kind = value$20 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
      let value$21 = value$18.id;
      let value$22 = value$18.__typename;
      customer = {
        __typename: value$22,
        id: value$21,
        kind: kind,
        hasSubscribedToLoyaltyProgram: value$19
      };
    } else {
      customer = null;
    }
    let value$23 = value$1.customerPhoneNumber;
    let customerPhoneNumber = value$23 !== undefined ? value$23 : null;
    let value$24 = value$1.customerIntraCommunityVAT;
    let customerIntraCommunityVAT = value$24 !== undefined ? value$24 : null;
    let value$25 = value$1.customerEmail;
    let customerEmail = value$25 !== undefined ? value$25 : null;
    let value$26 = value$1.customerCountry;
    let customerCountry = value$26 !== undefined ? value$26 : null;
    let value$27 = value$1.customerPostalCode;
    let customerPostalCode = value$27 !== undefined ? value$27 : null;
    let value$28 = value$1.customerCity;
    let customerCity = value$28 !== undefined ? value$28 : null;
    let value$29 = value$1.customerAddress;
    let customerAddress = value$29 !== undefined ? value$29 : null;
    let value$30 = value$1.customerName;
    let value$31 = value$1.name;
    let value$32 = value$1.id;
    let value$33 = value$1.__typename;
    let node = {
      __typename: value$33,
      id: value$32,
      name: value$31,
      customerName: value$30,
      customerAddress: customerAddress,
      customerCity: customerCity,
      customerPostalCode: customerPostalCode,
      customerCountry: customerCountry,
      customerEmail: customerEmail,
      customerIntraCommunityVAT: customerIntraCommunityVAT,
      customerPhoneNumber: customerPhoneNumber,
      customer: customer,
      createdAt: value$17,
      totalAmountIncludingTaxes: value$15,
      totalAmountExcludingTaxes: value$14,
      taxesIncluded: value$13,
      status: status,
      invoices: invoices,
      device: device,
      shop: shop
    };
    let value$34 = value.__typename;
    return {
      __typename: value$34,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let deliveryNotes = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    deliveryNotes: deliveryNotes
  };
}
function serializeInputObjectDateFilter$4(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInFilter$4(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectNullableInFilter$4(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => {
      if (b !== undefined) {
        return b;
      }
    })
  };
}
function serializeInputObjectInputDeliveryNotesQueryOrderBy(inp) {
  let a = inp.name;
  let a$1 = inp.totalAmountIncludingTaxes;
  let a$2 = inp.date;
  return {
    name: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    date: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeInputObjectInputDeliveryNotesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.createdAt;
  let a$2 = inp.customerId;
  let a$3 = inp.date;
  let a$4 = inp.status;
  let a$5 = inp.billingStatus;
  let a$6 = inp.deviceIds;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$4(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter$4(a$1) : undefined,
    customerId: a$2 !== undefined ? serializeInputObjectNullableInFilter$4(a$2) : undefined,
    date: a$3 !== undefined ? serializeInputObjectDateFilter$4(a$3) : undefined,
    status: a$4 !== undefined ? serializeInputObjectInFilter$4(a$4) : undefined,
    billingStatus: a$5 !== undefined ? serializeInputObjectInFilter$4(a$5) : undefined,
    deviceIds: a$6 !== undefined ? serializeInputObjectInFilter$4(a$6) : undefined
  };
}
function serializeVariables$4(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputDeliveryNotesQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputDeliveryNotesQueryOrderBy) : undefined
  };
}
function makeVariables$4(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}
function makeInputObjectInputDeliveryNotesQueryFilter(shopIds, createdAt, customerId, date, status, billingStatus, deviceIds, param) {
  return {
    shopIds: shopIds,
    createdAt: createdAt,
    customerId: customerId,
    date: date,
    status: status,
    billingStatus: billingStatus,
    deviceIds: deviceIds
  };
}
function makeInputObjectInFilter$4(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter$4(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableInFilter$4(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectInputDeliveryNotesQueryOrderBy(name, totalAmountIncludingTaxes, date, param) {
  return {
    name: name,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes,
    date: date
  };
}
function makeDefaultVariables$4() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}
let SalesListDeliveryNotesQuery_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  serializeInputObjectInputDeliveryNotesQueryFilter: serializeInputObjectInputDeliveryNotesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$4,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$4,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$4,
  serializeInputObjectInputDeliveryNotesQueryOrderBy: serializeInputObjectInputDeliveryNotesQueryOrderBy,
  makeVariables: makeVariables$4,
  makeInputObjectInputDeliveryNotesQueryFilter: makeInputObjectInputDeliveryNotesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$4,
  makeInputObjectDateFilter: makeInputObjectDateFilter$4,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$4,
  makeInputObjectInputDeliveryNotesQueryOrderBy: makeInputObjectInputDeliveryNotesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$4
};
let include$4 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$4,
  Raw: Raw$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4
});
let use$4 = include$4.use;
let SalesListDeliveryNotesQuery_refetchQueryDescription = include$4.refetchQueryDescription;
let SalesListDeliveryNotesQuery_useLazy = include$4.useLazy;
let SalesListDeliveryNotesQuery_useLazyWithVariables = include$4.useLazyWithVariables;
let SalesListDeliveryNotesQuery = {
  SalesListDeliveryNotesQuery_inner: SalesListDeliveryNotesQuery_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$4,
  serializeInputObjectInputDeliveryNotesQueryFilter: serializeInputObjectInputDeliveryNotesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$4,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$4,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$4,
  serializeInputObjectInputDeliveryNotesQueryOrderBy: serializeInputObjectInputDeliveryNotesQueryOrderBy,
  makeVariables: makeVariables$4,
  makeInputObjectInputDeliveryNotesQueryFilter: makeInputObjectInputDeliveryNotesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$4,
  makeInputObjectDateFilter: makeInputObjectDateFilter$4,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$4,
  makeInputObjectInputDeliveryNotesQueryOrderBy: makeInputObjectInputDeliveryNotesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$4,
  refetchQueryDescription: SalesListDeliveryNotesQuery_refetchQueryDescription,
  use: use$4,
  useLazy: SalesListDeliveryNotesQuery_useLazy,
  useLazyWithVariables: SalesListDeliveryNotesQuery_useLazyWithVariables
};
let Raw$5 = {};
let query$5 = Client.gql(["query SalesListQuotesQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputQuotesQueryFilter, $orderBy: [InputQuotesQueryOrderBy!])  {\nquotes(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy, orderBy: $orderBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \ncustomerName  \ncustomerAddress  \ncustomerCity  \ncustomerPostalCode  \ncustomerCountry  \ncustomerEmail  \ncustomerIntraCommunityVAT  \ncustomerPhoneNumber  \ncustomer  {\n__typename  \nid  \nkind  \nhasSubscribedToLoyaltyProgram  \n}\n\ncreatedAt  \ntotalAmountIncludingTaxes  \ntotalAmountExcludingTaxes  \ntaxesIncluded  \nstatus  \ninvoices  {\n__typename  \nid  \narchivedAt  \nname  \nissueDate  \nstatus  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\nshop  {\n__typename  \nid  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$5(value) {
  let value$1 = value.quotes;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    quotes: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.customerAddress;
        let value$3 = value$1.customerCity;
        let value$4 = value$1.customerPostalCode;
        let value$5 = value$1.customerCountry;
        let value$6 = value$1.customerEmail;
        let value$7 = value$1.customerIntraCommunityVAT;
        let value$8 = value$1.customerPhoneNumber;
        let value$9 = value$1.customer;
        let tmp;
        if (value$9 == null) {
          tmp = undefined;
        } else {
          let value$10 = value$9.kind;
          let tmp$1;
          switch (value$10) {
            case "BUSINESS":
              tmp$1 = "BUSINESS";
              break;
            case "CONSUMER":
              tmp$1 = "CONSUMER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp = {
            __typename: value$9.__typename,
            id: value$9.id,
            kind: tmp$1,
            hasSubscribedToLoyaltyProgram: value$9.hasSubscribedToLoyaltyProgram
          };
        }
        let value$11 = value$1.status;
        let tmp$2;
        switch (value$11) {
          case "ACCEPTED":
            tmp$2 = "ACCEPTED";
            break;
          case "PUBLISHED":
            tmp$2 = "PUBLISHED";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$12 = value$1.invoices;
        let value$13 = value$1.device;
        let value$14 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            customerName: value$1.customerName,
            customerAddress: !(value$2 == null) ? value$2 : undefined,
            customerCity: !(value$3 == null) ? value$3 : undefined,
            customerPostalCode: !(value$4 == null) ? value$4 : undefined,
            customerCountry: !(value$5 == null) ? value$5 : undefined,
            customerEmail: !(value$6 == null) ? value$6 : undefined,
            customerIntraCommunityVAT: !(value$7 == null) ? value$7 : undefined,
            customerPhoneNumber: !(value$8 == null) ? value$8 : undefined,
            customer: tmp,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            totalAmountIncludingTaxes: value$1.totalAmountIncludingTaxes,
            totalAmountExcludingTaxes: value$1.totalAmountExcludingTaxes,
            taxesIncluded: value$1.taxesIncluded,
            status: tmp$2,
            invoices: value$12.map(value => {
              let value$1 = value.archivedAt;
              let value$2 = value.status;
              let tmp;
              switch (value$2) {
                case "DRAFT":
                  tmp = "DRAFT";
                  break;
                case "PAID":
                  tmp = "PAID";
                  break;
                case "UNPAID":
                  tmp = "UNPAID";
                  break;
                default:
                  throw {
                    RE_EXN_ID: "Not_found",
                    Error: new Error()
                  };
              }
              return {
                __typename: value.__typename,
                id: value.id,
                archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
                name: value.name,
                issueDate: Scalar.Datetime.parse(value.issueDate),
                status: tmp
              };
            }),
            device: {
              __typename: value$13.__typename,
              id: value$13.id,
              name: value$13.name,
              slug: value$13.slug
            },
            shop: {
              __typename: value$14.__typename,
              id: value$14.id,
              name: value$14.name
            }
          }
        };
      })
    }
  };
}
function serialize$5(value) {
  let value$1 = value.quotes;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.name;
    let value$4 = value$2.id;
    let value$5 = value$2.__typename;
    let shop = {
      __typename: value$5,
      id: value$4,
      name: value$3
    };
    let value$6 = value$1.device;
    let value$7 = value$6.slug;
    let value$8 = value$6.name;
    let value$9 = value$6.id;
    let value$10 = value$6.__typename;
    let device = {
      __typename: value$10,
      id: value$9,
      name: value$8,
      slug: value$7
    };
    let value$11 = value$1.invoices;
    let invoices = value$11.map(value => {
      let value$1 = value.status;
      let status = value$1 === "UNPAID" ? "UNPAID" : value$1 === "PAID" ? "PAID" : "DRAFT";
      let value$2 = value.issueDate;
      let value$3 = Scalar.Datetime.serialize(value$2);
      let value$4 = value.name;
      let value$5 = value.archivedAt;
      let archivedAt = value$5 !== undefined ? Scalar.Datetime.serialize(value$5) : null;
      let value$6 = value.id;
      let value$7 = value.__typename;
      return {
        __typename: value$7,
        id: value$6,
        archivedAt: archivedAt,
        name: value$4,
        issueDate: value$3,
        status: status
      };
    });
    let value$12 = value$1.status;
    let status = value$12 === "ACCEPTED" ? "ACCEPTED" : "PUBLISHED";
    let value$13 = value$1.taxesIncluded;
    let value$14 = value$1.totalAmountExcludingTaxes;
    let value$15 = value$1.totalAmountIncludingTaxes;
    let value$16 = value$1.createdAt;
    let value$17 = Scalar.Datetime.serialize(value$16);
    let value$18 = value$1.customer;
    let customer;
    if (value$18 !== undefined) {
      let value$19 = value$18.hasSubscribedToLoyaltyProgram;
      let value$20 = value$18.kind;
      let kind = value$20 === "CONSUMER" ? "CONSUMER" : "BUSINESS";
      let value$21 = value$18.id;
      let value$22 = value$18.__typename;
      customer = {
        __typename: value$22,
        id: value$21,
        kind: kind,
        hasSubscribedToLoyaltyProgram: value$19
      };
    } else {
      customer = null;
    }
    let value$23 = value$1.customerPhoneNumber;
    let customerPhoneNumber = value$23 !== undefined ? value$23 : null;
    let value$24 = value$1.customerIntraCommunityVAT;
    let customerIntraCommunityVAT = value$24 !== undefined ? value$24 : null;
    let value$25 = value$1.customerEmail;
    let customerEmail = value$25 !== undefined ? value$25 : null;
    let value$26 = value$1.customerCountry;
    let customerCountry = value$26 !== undefined ? value$26 : null;
    let value$27 = value$1.customerPostalCode;
    let customerPostalCode = value$27 !== undefined ? value$27 : null;
    let value$28 = value$1.customerCity;
    let customerCity = value$28 !== undefined ? value$28 : null;
    let value$29 = value$1.customerAddress;
    let customerAddress = value$29 !== undefined ? value$29 : null;
    let value$30 = value$1.customerName;
    let value$31 = value$1.name;
    let value$32 = value$1.id;
    let value$33 = value$1.__typename;
    let node = {
      __typename: value$33,
      id: value$32,
      name: value$31,
      customerName: value$30,
      customerAddress: customerAddress,
      customerCity: customerCity,
      customerPostalCode: customerPostalCode,
      customerCountry: customerCountry,
      customerEmail: customerEmail,
      customerIntraCommunityVAT: customerIntraCommunityVAT,
      customerPhoneNumber: customerPhoneNumber,
      customer: customer,
      createdAt: value$17,
      totalAmountIncludingTaxes: value$15,
      totalAmountExcludingTaxes: value$14,
      taxesIncluded: value$13,
      status: status,
      invoices: invoices,
      device: device,
      shop: shop
    };
    let value$34 = value.__typename;
    return {
      __typename: value$34,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let quotes = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    quotes: quotes
  };
}
function serializeInputObjectNullableInFilter$5(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => {
      if (b !== undefined) {
        return b;
      }
    })
  };
}
function serializeInputObjectInFilter$5(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectDateFilter$5(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInputQuotesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.createdAt;
  let a$2 = inp.customerId;
  let a$3 = inp.status;
  let a$4 = inp.billingStatus;
  let a$5 = inp.deviceIds;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$5(a) : undefined,
    createdAt: a$1 !== undefined ? serializeInputObjectDateFilter$5(a$1) : undefined,
    customerId: a$2 !== undefined ? serializeInputObjectNullableInFilter$5(a$2) : undefined,
    status: a$3 !== undefined ? serializeInputObjectInFilter$5(a$3) : undefined,
    billingStatus: a$4 !== undefined ? serializeInputObjectInFilter$5(a$4) : undefined,
    deviceIds: a$5 !== undefined ? serializeInputObjectInFilter$5(a$5) : undefined
  };
}
function serializeInputObjectInputQuotesQueryOrderBy(inp) {
  let a = inp.name;
  let a$1 = inp.totalAmountIncludingTaxes;
  let a$2 = inp.createdAt;
  return {
    name: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    totalAmountIncludingTaxes: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    createdAt: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeVariables$5(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  let a$6 = inp.orderBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputQuotesQueryFilter(a$5) : undefined,
    orderBy: a$6 !== undefined ? a$6.map(serializeInputObjectInputQuotesQueryOrderBy) : undefined
  };
}
function makeVariables$5(search, before, after, first, last, filterBy, orderBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy,
    orderBy: orderBy
  };
}
function makeInputObjectInputQuotesQueryFilter(shopIds, createdAt, customerId, status, billingStatus, deviceIds, param) {
  return {
    shopIds: shopIds,
    createdAt: createdAt,
    customerId: customerId,
    status: status,
    billingStatus: billingStatus,
    deviceIds: deviceIds
  };
}
function makeInputObjectInFilter$5(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectDateFilter$5(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableInFilter$5(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectInputQuotesQueryOrderBy(name, totalAmountIncludingTaxes, createdAt, param) {
  return {
    name: name,
    totalAmountIncludingTaxes: totalAmountIncludingTaxes,
    createdAt: createdAt
  };
}
function makeDefaultVariables$5() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined,
    orderBy: undefined
  };
}
let SalesListQuotesQuery_inner = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputQuotesQueryFilter: serializeInputObjectInputQuotesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$5,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$5,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$5,
  serializeInputObjectInputQuotesQueryOrderBy: serializeInputObjectInputQuotesQueryOrderBy,
  makeVariables: makeVariables$5,
  makeInputObjectInputQuotesQueryFilter: makeInputObjectInputQuotesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$5,
  makeInputObjectDateFilter: makeInputObjectDateFilter$5,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$5,
  makeInputObjectInputQuotesQueryOrderBy: makeInputObjectInputQuotesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$5
};
let include$5 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$5,
  Raw: Raw$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5
});
let use$5 = include$5.use;
let SalesListQuotesQuery_refetchQueryDescription = include$5.refetchQueryDescription;
let SalesListQuotesQuery_useLazy = include$5.useLazy;
let SalesListQuotesQuery_useLazyWithVariables = include$5.useLazyWithVariables;
let SalesListQuotesQuery = {
  SalesListQuotesQuery_inner: SalesListQuotesQuery_inner,
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputQuotesQueryFilter: serializeInputObjectInputQuotesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$5,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$5,
  serializeInputObjectNullableInFilter: serializeInputObjectNullableInFilter$5,
  serializeInputObjectInputQuotesQueryOrderBy: serializeInputObjectInputQuotesQueryOrderBy,
  makeVariables: makeVariables$5,
  makeInputObjectInputQuotesQueryFilter: makeInputObjectInputQuotesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$5,
  makeInputObjectDateFilter: makeInputObjectDateFilter$5,
  makeInputObjectNullableInFilter: makeInputObjectNullableInFilter$5,
  makeInputObjectInputQuotesQueryOrderBy: makeInputObjectInputQuotesQueryOrderBy,
  makeDefaultVariables: makeDefaultVariables$5,
  refetchQueryDescription: SalesListQuotesQuery_refetchQueryDescription,
  use: use$5,
  useLazy: SalesListQuotesQuery_useLazy,
  useLazyWithVariables: SalesListQuotesQuery_useLazyWithVariables
};
function renderTooltipContent(content, getSublabelTemplate) {
  let sorted = content.toSorted((current, next) => Primitive_float.compare(current.date.getTime(), next.date.getTime()));
  if (sorted.length > 1) {
    return View.map(sorted, item => {
      let formattedDate = DateHelpers.formateToShortDate(item.date);
      let formattedTime = DateHelpers.formateToShortTime(undefined, item.date);
      return JsxRuntime.jsxs(React.Fragment, {
        children: [JsxRuntime.jsx(Tooltip.Span.make, {
          text: `• ` + item.label + ` - `,
          bold: true
        }), JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.template(getSublabelTemplate(item.date), {
            date: formattedDate,
            time: formattedTime
          }, undefined)
        }), JsxRuntime.jsx(Tooltip.Gap.make, {
          space: "xxsmall"
        })]
      }, item.label);
    });
  } else {
    return View.mapOption(sorted[0], item => {
      let formattedDate = DateHelpers.formateToShortDate(item.date);
      let formattedTime = DateHelpers.formateToShortTime(undefined, item.date);
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(Tooltip.Span.make, {
          text: item.label,
          bold: true
        }), JsxRuntime.jsx(Tooltip.Gap.make, {
          space: "xxsmall"
        }), JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.template(getSublabelTemplate(item.date), {
            date: formattedDate,
            time: formattedTime
          }, undefined)
        })]
      });
    });
  }
}
let make = React.memo(props => {
  let refundReason = props.refundReason;
  let creditNotesDetails = props.creditNotesDetails;
  let invoiceDetails = props.invoiceDetails;
  let __hideLabel = props.hideLabel;
  let __progressAmountPercent = props.progressAmountPercent;
  let saleType = props.saleType;
  let value = props.value;
  let progressAmountPercent = __progressAmountPercent !== undefined ? __progressAmountPercent : 1.00;
  let hideLabel = __hideLabel !== undefined ? __hideLabel : false;
  let partiallyPaid = progressAmountPercent > 0 && progressAmountPercent < 1.00;
  let showProgressPie = partiallyPaid && (value === "Started" || value === "Overdue" || value === "Canceled" && saleType === "Invoice");
  let styleSet = Sale.Status.Badge.toStyleSet(value, saleType);
  let progressPieSvg;
  if (showProgressPie) {
    let formattedTooltipContent = I18n.percentFormat(undefined, undefined, 0, progressAmountPercent) + " " + (value === "Canceled" && saleType === "Invoice" ? I18n.t("settled") : I18n.t("paid"));
    progressPieSvg = JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx(ProgressPieIcon.make, {
        value: progressAmountPercent,
        color: value !== "Canceled" || saleType !== "Invoice" ? "#7A360D" : "#25243A"
      }),
      placement: "top",
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: formattedTooltipContent
      })
    });
  } else {
    progressPieSvg = undefined;
  }
  let creditNotesCount = Stdlib_Option.mapOr(creditNotesDetails, 0, prim => prim.length);
  let label = Sale.Status.toLabel(partiallyPaid, saleType, value) + (creditNotesCount > 1 ? " ×" + creditNotesCount.toString() : "");
  let tooltipContent;
  tooltipContent = value === "Canceled" ? saleType === "Invoice" ? View.mapOption(creditNotesDetails, __x => renderTooltipContent(__x, param => I18n.t("Settled on {{date}} at {{time}}"))) : saleType === "RefundReceipt" ? View.mapOption(refundReason, reason => JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Reason") + I18n.t(":") + " ",
      bold: true
    }), JsxRuntime.jsx(Tooltip.Span.make, {
      text: Sale.RefundReceiptReason.toLabel(reason)
    })]
  })) : View.mapOption(invoiceDetails, __x => renderTooltipContent(__x, param => I18n.t("Transformed on {{date}} at {{time}}"))) : null;
  let tooltipDisabled;
  tooltipDisabled = value === "Canceled" ? saleType === "Invoice" ? creditNotesDetails !== undefined || invoiceDetails !== undefined ? false : Stdlib_Option.isNone(refundReason) : invoiceDetails !== undefined ? false : Stdlib_Option.isNone(refundReason) : Stdlib_Option.isNone(refundReason);
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Badge.make, {
      children: hideLabel ? null : label,
      iconSvg: styleSet.iconSvg,
      endIconSvg: progressPieSvg,
      size: "medium",
      borderColor: styleSet.borderColor,
      backgroundColor: styleSet.bgColor,
      foregroundColor: styleSet.textColor
    }),
    placement: "top",
    content: tooltipContent,
    disabled: tooltipDisabled
  });
});
let SalesListPageStatusBadge = {
  make: make
};
let make$1 = React.memo(props => {
  let __hideLabel = props.hideLabel;
  let refundReason = props.refundReason;
  let __details = props.details;
  let value = props.value;
  let details = __details !== undefined ? __details : [];
  let hideLabel = __hideLabel !== undefined ? __hideLabel : false;
  let detailsCount = details.length;
  let styleSet = Sale.BusinessSecondaryStatus.Badge.toStyleSet(value);
  let labelElement;
  let exit = 0;
  if (hideLabel) {
    labelElement = null;
  } else {
    switch (value) {
      case "Refunded":
        labelElement = null;
        break;
      case "Delivered":
      case "Billed":
        exit = 1;
        break;
    }
  }
  if (exit === 1) {
    labelElement = detailsCount > 1 ? "×" + detailsCount.toString() : null;
  }
  let tooltipContent;
  let exit$1 = 0;
  switch (value) {
    case "Refunded":
      if (refundReason !== undefined) {
        tooltipContent = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("Reason") + I18n.t(":") + " ",
            bold: true
          }), JsxRuntime.jsx(Tooltip.Span.make, {
            text: Sale.RefundReceiptReason.toLabel(refundReason)
          })]
        });
      } else {
        exit$1 = 1;
      }
      break;
    case "Delivered":
    case "Billed":
      exit$1 = 1;
      break;
  }
  if (exit$1 === 1) {
    tooltipContent = renderTooltipContent(details, param => {
      let tmp;
      switch (value) {
        case "Delivered":
          tmp = "Delivered";
          break;
        case "Refunded":
          tmp = "Refunded";
          break;
        case "Billed":
          tmp = "Billed";
          break;
      }
      return I18n.t(tmp + " on {{date}} at {{time}}");
    });
  }
  let tooltipDisabled = value === "Refunded" && Stdlib_Option.isSome(refundReason) ? false : detailsCount === 0;
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Badge.make, {
      children: labelElement,
      iconSvg: styleSet.iconSvg,
      size: "medium",
      borderColor: styleSet.borderColor,
      backgroundColor: styleSet.bgColor,
      foregroundColor: styleSet.textColor
    }),
    placement: "top",
    content: tooltipContent,
    disabled: tooltipDisabled
  });
});
let SalesListPageSecondaryStatusBadge = {
  make: make$1
};
function keyExtractor(param) {
  return param.id;
}
function settledPercent(rawCreditNotes, invoiceTotalAmountIncludingTaxes) {
  let total = BigJs.Big(invoiceTotalAmountIncludingTaxes);
  if (total.toNumber() === 0) {
    return 0;
  }
  let settled = Stdlib_Array.reduce(rawCreditNotes, BigJs.Big(0), (acc, creditNote) => Big.Operators.$plus$dot(acc, BigJs.Big(creditNote.totalAmountIncludingTaxes)));
  return Big.Operators.$slash$dot(settled, total).toNumber();
}
function paymentBalance(totalAmountIncludingTaxes, payments, status) {
  let total = BigJs.Big(totalAmountIncludingTaxes);
  let paidSum = Stdlib_Array.reduce(payments, BigJs.Big(0), (acc, payment) => Big.Operators.$plus$dot(acc, Big.Operators.$neg$dot(BigJs.Big(payment.amountReceived), BigJs.Big(payment.amountReturned))));
  let remainder = Big.Operators.$neg$dot(total, paidSum);
  let result = Big.Operators.$neg$dot(BigJs.Big(totalAmountIncludingTaxes), remainder);
  let paidAmount = result.toNumber() > 0 ? result.toNumber() : undefined;
  let total$1 = BigJs.Big(totalAmountIncludingTaxes);
  let paidPercent;
  if (total$1.toNumber() !== 0) {
    let paid = Big.Operators.$neg$dot(total$1, remainder);
    paidPercent = Big.Operators.$slash$dot(paid, total$1).toNumber();
  } else {
    paidPercent = 0;
  }
  if (status !== "Completed") {
    return {
      remainingAmount: remainder.toNumber(),
      paidAmount: paidAmount,
      paidPercent: paidPercent
    };
  }
}
function paymentMethods(paymentMethods$1) {
  if (paymentMethods$1.length !== 0) {
    return paymentMethods$1.map(PaymentMethod.fromRawValue);
  }
}
function paymentsComponents(rawPaymentsComponents) {
  let filteredPaymentsComponents = rawPaymentsComponents.map(payment => ({
    amountReceived: payment.amountReceived,
    amountReturned: payment.amountReturned,
    date: payment.date
  }));
  return filteredPaymentsComponents.filter(paymentComponents => paymentComponents.amountReceived !== 0);
}
function paymentDates(paymentsComponents) {
  if (paymentsComponents.length !== 0) {
    return {
      primary: paymentsComponents[paymentsComponents.length - 1 | 0].date,
      all: paymentsComponents.length > 1 ? paymentsComponents.map(payment => payment.date) : undefined
    };
  }
}
function source(deviceId, deviceSlug, deviceName, shopId, shopName) {
  return {
    deviceId: deviceId,
    deviceLabel: DeviceName.format(DeviceName.decode(deviceSlug, deviceName)),
    shopId: shopId,
    shopName: shopName
  };
}
let SalesListTableRow = {
  keyExtractor: keyExtractor,
  settledPercent: settledPercent,
  paymentBalance: paymentBalance,
  paymentMethods: paymentMethods,
  paymentsComponents: paymentsComponents,
  paymentDates: paymentDates,
  source: source
};
function invoicesTableRowsFromQueryResult(queryResult) {
  return queryResult.invoices.edges.map(param => {
    let node = param.node;
    let status = Sale.Status.fromRaw(node.dueDate, node.creditNotes.length !== 0, undefined, node.status);
    let paymentsComponents$1 = paymentsComponents(node.payments);
    return {
      id: node.id,
      saleType: "Invoice",
      reference: {
        id: node.id,
        name: node.name,
        relatedReferences: {
          quote: Stdlib_Option.map(node.parentQuote, param => ({
            id: param.id,
            name: param.name,
            date: param.createdAt
          })),
          salesReceipt: Stdlib_Option.map(node.salesReceipt, param => ({
            id: param.id,
            name: param.name,
            date: param.createdAt
          })),
          deliveryNotes: Stdlib_Array.filterMap(node.deliveryNotes, param => {
            if (param.status === "PUBLISHED") {
              return {
                id: param.id,
                name: param.name,
                date: param.date
              };
            }
          }),
          creditNotes: {
            items: node.creditNotes.map(param => ({
              id: param.id,
              name: param.name,
              date: param.createdAt
            })),
            settledPercent: settledPercent(node.creditNotes, node.totalAmountIncludingTaxes)
          }
        }
      },
      customer: node.customerName.trim() !== "" ? {
        id: Stdlib_Option.map(node.customer, customer => customer.id),
        name: node.customerName,
        business: Stdlib_Option.mapOr(node.customer, false, param => param.kind === "BUSINESS"),
        loyaltyProgramMember: Stdlib_Option.mapOr(node.customer, false, param => param.hasSubscribedToLoyaltyProgram)
      } : undefined,
      date: node.issueDate,
      dueDate: node.dueDate,
      totalAmounts: {
        includingTaxes: node.totalAmountIncludingTaxes,
        excludingTaxes: node.totalAmountExcludingTaxes,
        taxesIncluded: node.taxesIncluded
      },
      status: status,
      eInvoicingWorkflowState: node.electronicInvoicingWorkflowState,
      paymentBalance: paymentBalance(node.totalAmountIncludingTaxes, paymentsComponents$1, status),
      paymentMethods: paymentMethods(node.payments.map(payment => payment.method)),
      paymentDates: paymentDates(paymentsComponents$1),
      source: source(node.device.id, node.device.slug, node.device.name, node.shop.id, node.shop.name)
    };
  });
}
function salesReceiptsTableRowsFromQueryResult(queryResult) {
  return queryResult.salesReceipts.edges.map(param => {
    let node = param.node;
    return {
      id: node.id,
      saleType: "SalesReceipt",
      reference: {
        id: node.id,
        name: node.name,
        relatedReferences: {
          invoices: Stdlib_Option.mapOr(node.invoice, [], param => [{
            id: param.id,
            name: param.name,
            date: param.createdAt
          }]),
          refundReceipts: node.refundReceipts.map(param => ({
            id: param.id,
            name: param.name,
            date: param.createdAt
          }))
        }
      },
      customer: Stdlib_Option.map(node.customer, customer => ({
        id: customer.id,
        name: Stdlib_Option.getOr(Customer.makeName(customer.firstName, customer.lastName, customer.companyName), Placeholder.Empty.text),
        business: customer.kind === "BUSINESS",
        loyaltyProgramMember: customer.hasSubscribedToLoyaltyProgram
      })),
      date: node.createdAt,
      totalAmounts: {
        includingTaxes: node.totalAmountIncludingTaxes,
        excludingTaxes: node.totalAmountExcludingTaxes,
        taxesIncluded: node.taxesIncluded
      },
      status: Sale.Status.fromRaw(undefined, undefined, Stdlib_Option.isSome(node.invoice), "PAID"),
      paymentMethods: paymentMethods(node.payments.map(payment => payment.method)),
      paymentDates: {
        primary: node.createdAt
      },
      source: source(node.device.id, node.device.slug, node.device.name, node.shop.id, node.shop.name)
    };
  });
}
function creditNotesTableRowsFromQueryResult(queryResult) {
  return queryResult.creditNotes.edges.map(param => {
    let node = param.node;
    return {
      id: node.id,
      saleType: "CreditNote",
      reference: {
        id: node.id,
        name: node.name,
        relatedReferences: {
          invoices: Stdlib_Option.mapOr(node.parentInvoice, [], param => [{
            id: param.id,
            name: param.name,
            date: param.issueDate
          }])
        }
      },
      customer: node.customerName.trim() !== "" ? {
        id: Stdlib_Option.map(node.customer, customer => customer.id),
        name: node.customerName,
        business: Stdlib_Option.mapOr(node.customer, false, param => param.kind === "BUSINESS"),
        loyaltyProgramMember: Stdlib_Option.mapOr(node.customer, false, param => param.hasSubscribedToLoyaltyProgram)
      } : undefined,
      date: node.createdAt,
      totalAmounts: {
        includingTaxes: node.totalAmountIncludingTaxes,
        excludingTaxes: node.totalAmountExcludingTaxes,
        taxesIncluded: node.taxesIncluded
      },
      paymentDates: {
        primary: node.createdAt
      },
      source: source(node.device.id, node.device.slug, node.device.name, node.shop.id, node.shop.name)
    };
  });
}
function refundReceiptsTableRowsFromQueryResult(queryResult) {
  return queryResult.refundReceipts.edges.map(param => {
    let node = param.node;
    return {
      id: node.id,
      saleType: "RefundReceipt",
      reference: {
        id: node.id,
        name: node.name,
        relatedReferences: {
          salesReceipt: {
            id: node.salesReceipt.id,
            name: node.salesReceipt.name,
            date: node.salesReceipt.createdAt
          }
        },
        refundReason: Sale.RefundReceiptReason.fromRaw(node.reason)
      },
      customer: Stdlib_Option.map(node.customer, customer => ({
        id: customer.id,
        name: Stdlib_Option.getOr(Customer.makeName(customer.firstName, customer.lastName, customer.companyName), Placeholder.Empty.text),
        business: customer.kind === "BUSINESS",
        loyaltyProgramMember: customer.hasSubscribedToLoyaltyProgram
      })),
      date: node.createdAt,
      totalAmounts: {
        includingTaxes: node.totalAmountIncludingTaxes,
        excludingTaxes: node.totalAmountExcludingTaxes,
        taxesIncluded: node.totalAmountOfTaxes > 0
      },
      status: "Canceled",
      paymentMethods: paymentMethods(node.payments.map(payment => payment.method)),
      paymentDates: {
        primary: node.createdAt
      },
      source: source(node.device.id, node.device.slug, node.device.name, node.shop.id, node.shop.name)
    };
  });
}
function deliveryNotesTableRowsFromQueryResult(queryResult) {
  return queryResult.deliveryNotes.edges.map(param => {
    let node = param.node;
    let match = node.status;
    return {
      id: node.id,
      saleType: "DeliveryNote",
      reference: {
        id: node.id,
        name: node.name,
        relatedReferences: {
          invoices: Stdlib_Array.filterMap(node.invoices, param => {
            if (param.status !== "DRAFT" && Stdlib_Option.isNone(param.archivedAt)) {
              return {
                id: param.id,
                name: param.name,
                date: param.issueDate
              };
            }
          })
        }
      },
      customer: node.customerName.trim() !== "" ? {
        id: Stdlib_Option.map(node.customer, customer => customer.id),
        name: node.customerName,
        business: Stdlib_Option.mapOr(node.customer, false, param => param.kind === "BUSINESS"),
        loyaltyProgramMember: Stdlib_Option.mapOr(node.customer, false, param => param.hasSubscribedToLoyaltyProgram)
      } : undefined,
      date: node.createdAt,
      totalAmounts: {
        includingTaxes: node.totalAmountIncludingTaxes,
        excludingTaxes: node.totalAmountExcludingTaxes,
        taxesIncluded: node.taxesIncluded
      },
      status: match === "DRAFT" ? "Draft" : "Completed",
      source: source(node.device.id, node.device.slug, node.device.name, node.shop.id, node.shop.name)
    };
  });
}
function quotesTableRowsFromQueryResult(queryResult) {
  return queryResult.quotes.edges.map(param => {
    let node = param.node;
    let match = node.status;
    return {
      id: node.id,
      saleType: "Quote",
      reference: {
        id: node.id,
        name: node.name,
        relatedReferences: {
          invoices: Stdlib_Array.filterMap(node.invoices, param => {
            if (param.status !== "DRAFT" && Stdlib_Option.isNone(param.archivedAt)) {
              return {
                id: param.id,
                name: param.name,
                date: param.issueDate
              };
            }
          })
        }
      },
      customer: node.customerName.trim() !== "" ? {
        id: Stdlib_Option.map(node.customer, customer => customer.id),
        name: node.customerName,
        business: Stdlib_Option.mapOr(node.customer, false, param => param.kind === "BUSINESS"),
        loyaltyProgramMember: Stdlib_Option.mapOr(node.customer, false, param => param.hasSubscribedToLoyaltyProgram)
      } : undefined,
      date: node.createdAt,
      totalAmounts: {
        includingTaxes: node.totalAmountIncludingTaxes,
        excludingTaxes: node.totalAmountExcludingTaxes,
        taxesIncluded: node.taxesIncluded
      },
      status: match === "ACCEPTED" ? "Completed" : "Started",
      source: source(node.device.id, node.device.slug, node.device.name, node.shop.id, node.shop.name)
    };
  });
}
function make$2(shopId, customerId, deviceIdsOpt, paymentMethodsOpt, statusesOpt, delivered, billed, date, dueDate) {
  let deviceIds = deviceIdsOpt !== undefined ? deviceIdsOpt : [];
  let paymentMethods = paymentMethodsOpt !== undefined ? paymentMethodsOpt : [];
  let statuses = statusesOpt !== undefined ? statusesOpt : [];
  return {
    shopId: shopId,
    customerId: customerId,
    deviceIds: deviceIds,
    paymentMethods: paymentMethods,
    statuses: statuses,
    delivered: delivered,
    billed: billed,
    date: date,
    dueDate: dueDate
  };
}
function encodeValues(values) {
  if (values.length !== 0) {
    return values;
  }
}
function unionIn(statuses, toValues) {
  if (statuses.length !== 0) {
    return Stdlib_Array.reduce(statuses, [], (acc, status) => {
      let match = toValues(status);
      if (acc !== undefined && match !== undefined) {
        return Stdlib_Array.reduce(match, acc, (acc, value) => {
          if (acc.includes(value)) {
            return acc;
          } else {
            return acc.concat([value]);
          }
        });
      }
    });
  }
}
let SalesTableQueryFilters = {
  make: make$2,
  encodeValues: encodeValues,
  unionIn: unionIn
};
function toSortDescriptor(sort) {
  switch (sort.TAG) {
    case "Name":
      return {
        column: "name",
        direction: sort._0
      };
    case "Date":
      return {
        column: "date",
        direction: sort._0
      };
    case "TotalAmount":
      return {
        column: "total-amount",
        direction: sort._0
      };
  }
}
function fromSortDescriptor(sort) {
  switch (sort.column) {
    case "date":
      return {
        TAG: "Ok",
        _0: {
          TAG: "Date",
          _0: sort.direction
        }
      };
    case "name":
      return {
        TAG: "Ok",
        _0: {
          TAG: "Name",
          _0: sort.direction
        }
      };
    case "total-amount":
      return {
        TAG: "Ok",
        _0: {
          TAG: "TotalAmount",
          _0: sort.direction
        }
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}
let jsonCodec = JsonCodec.object2(sort => [toSortDescriptor(sort).column, toSortDescriptor(sort).direction], param => {
  let direction = param[1] === "descending" ? "descending" : "ascending";
  let ok = fromSortDescriptor({
    column: param[0],
    direction: direction
  });
  if (ok.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: ok._0
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Invalid sort descriptor"
      }
    };
  }
}, JsonCodec.field("column", JsonCodec.string), JsonCodec.field("direction", JsonCodec.string));
let SalesTableSorting = {
  toSortDescriptor: toSortDescriptor,
  fromSortDescriptor: fromSortDescriptor,
  jsonCodec: jsonCodec
};
function invoicesQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        name: toRawDirection(sort._0),
        issueDate: undefined,
        totalAmountIncludingTaxes: undefined
      };
    case "Date":
      return {
        name: undefined,
        issueDate: toRawDirection(sort._0),
        totalAmountIncludingTaxes: undefined
      };
    case "TotalAmount":
      return {
        name: undefined,
        issueDate: undefined,
        totalAmountIncludingTaxes: toRawDirection(sort._0)
      };
  }
}
function salesReceiptsQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        name: toRawDirection(sort._0),
        createdAt: undefined,
        totalAmountIncludingTaxes: undefined
      };
    case "Date":
      return {
        name: undefined,
        createdAt: toRawDirection(sort._0),
        totalAmountIncludingTaxes: undefined
      };
    case "TotalAmount":
      return {
        name: undefined,
        createdAt: undefined,
        totalAmountIncludingTaxes: toRawDirection(sort._0)
      };
  }
}
function creditNotesQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        name: toRawDirection(sort._0),
        createdAt: undefined,
        totalAmountIncludingTaxes: undefined
      };
    case "Date":
      return {
        name: undefined,
        createdAt: toRawDirection(sort._0),
        totalAmountIncludingTaxes: undefined
      };
    case "TotalAmount":
      return {
        name: undefined,
        createdAt: undefined,
        totalAmountIncludingTaxes: toRawDirection(sort._0) === "ASC" ? "DESC" : "ASC"
      };
  }
}
function refundReceiptsQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        name: toRawDirection(sort._0),
        createdAt: undefined,
        totalAmountIncludingTaxes: undefined
      };
    case "Date":
      return {
        name: undefined,
        createdAt: toRawDirection(sort._0),
        totalAmountIncludingTaxes: undefined
      };
    case "TotalAmount":
      return {
        name: undefined,
        createdAt: undefined,
        totalAmountIncludingTaxes: toRawDirection(sort._0) === "ASC" ? "DESC" : "ASC"
      };
  }
}
function deliveryNotesQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        name: toRawDirection(sort._0),
        totalAmountIncludingTaxes: undefined,
        date: undefined
      };
    case "Date":
      return {
        name: undefined,
        totalAmountIncludingTaxes: undefined,
        date: toRawDirection(sort._0)
      };
    case "TotalAmount":
      return {
        name: undefined,
        totalAmountIncludingTaxes: toRawDirection(sort._0),
        date: undefined
      };
  }
}
function quotesQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        name: toRawDirection(sort._0),
        totalAmountIncludingTaxes: undefined,
        createdAt: undefined
      };
    case "Date":
      return {
        name: undefined,
        totalAmountIncludingTaxes: undefined,
        createdAt: toRawDirection(sort._0)
      };
    case "TotalAmount":
      return {
        name: undefined,
        totalAmountIncludingTaxes: toRawDirection(sort._0),
        createdAt: undefined
      };
  }
}
function salesReceiptsQueryVariablesFilterBy(param) {
  let date = param.date;
  let customerId = param.customerId;
  let shopId = param.shopId;
  let paymentStatuses = unionIn(param.statuses, status => {
    switch (status) {
      case "Completed":
        return ["PAID"];
      case "Canceled":
        return ["CANCELLED"];
      default:
        return;
    }
  });
  let paymentMethods = encodeValues(param.paymentMethods);
  let deviceIds = encodeValues(param.deviceIds);
  return {
    shopIds: shopId !== undefined ? {
      _in: [shopId]
    } : undefined,
    createdAt: date !== undefined ? {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(date[0]), Scalar.Datetime.serialize(date[1])]
    } : undefined,
    customerId: customerId !== undefined ? {
      _in: [Primitive_option.fromNullable(Primitive_option.valFromOption(customerId))]
    } : undefined,
    paymentStatus: paymentStatuses !== undefined ? {
      _in: paymentStatuses
    } : {
      _in: ["PAID", "CANCELLED"]
    },
    paymentMethod: paymentMethods !== undefined ? {
      _in: paymentMethods.map(PaymentMethod.toRawString)
    } : undefined,
    deviceIds: deviceIds !== undefined ? {
      _in: deviceIds
    } : undefined
  };
}
function salesReceiptsQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: salesReceiptsQueryVariablesFilterBy(param.filters),
    orderBy: [salesReceiptsQueryVariablesOrderBy(param.sorting)]
  };
}
function invoicesQueryVariablesFilterBy(param) {
  let dueDate = param.dueDate;
  let date = param.date;
  let delivered = param.delivered;
  let statuses = param.statuses;
  let customerId = param.customerId;
  let shopId = param.shopId;
  let statuses$1 = unionIn(statuses, status => {
    switch (status) {
      case "Draft":
        return ["DRAFT"];
      case "Started":
      case "Overdue":
        return ["UNPAID"];
      case "Completed":
        return ["PAID"];
      case "Canceled":
        return ["UNPAID", "PAID"];
    }
  });
  let documentStatuses = unionIn(statuses, status => {
    if (status === "Draft") {
      return ["DRAFT"];
    } else {
      return ["FINALIZED"];
    }
  });
  let paymentStatuses = unionIn(statuses, status => {
    switch (status) {
      case "Draft":
        return;
      case "Started":
        return ["UNPAID"];
      case "Overdue":
        return ["OVERDUE"];
      case "Completed":
        return ["PAID"];
      case "Canceled":
        return ["SETTLED_BY_CREDIT_NOTE"];
    }
  });
  let paymentMethods = encodeValues(param.paymentMethods);
  let deviceIds = encodeValues(param.deviceIds);
  return {
    shopIds: shopId !== undefined ? {
      _in: [shopId]
    } : undefined,
    createdAt: undefined,
    issueDate: date !== undefined ? {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(date[0]), Scalar.Datetime.serialize(date[1])]
    } : undefined,
    dueDate: dueDate !== undefined ? {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(dueDate[0]), Scalar.Datetime.serialize(dueDate[1])]
    } : undefined,
    customerId: customerId !== undefined ? {
      _in: [Primitive_option.fromNullable(Primitive_option.valFromOption(customerId))]
    } : undefined,
    status: statuses$1 !== undefined ? {
      _in: statuses$1
    } : undefined,
    documentStatus: documentStatuses !== undefined ? {
      _in: documentStatuses
    } : {
      _in: ["FINALIZED"]
    },
    paymentStatus: paymentStatuses !== undefined ? {
      _in: paymentStatuses
    } : undefined,
    paymentMethod: paymentMethods !== undefined ? {
      _in: paymentMethods.map(PaymentMethod.toRawString)
    } : undefined,
    deliveryStatus: delivered !== undefined ? delivered ? {
      _in: ["DELIVERED"]
    } : {
      _in: ["NOT_DELIVERED"]
    } : undefined,
    deviceIds: deviceIds !== undefined ? {
      _in: deviceIds
    } : undefined
  };
}
function invoicesQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: invoicesQueryVariablesFilterBy(param.filters),
    orderBy: [invoicesQueryVariablesOrderBy(param.sorting)]
  };
}
function refundReceiptsQueryVariablesFilterBy(param) {
  let date = param.date;
  let customerId = param.customerId;
  let shopId = param.shopId;
  let paymentMethods = encodeValues(param.paymentMethods);
  let deviceIds = encodeValues(param.deviceIds);
  return {
    shopIds: shopId !== undefined ? {
      _in: [shopId]
    } : undefined,
    createdAt: date !== undefined ? {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(date[0]), Scalar.Datetime.serialize(date[1])]
    } : undefined,
    customerId: customerId !== undefined ? {
      _in: [Primitive_option.fromNullable(Primitive_option.valFromOption(customerId))]
    } : undefined,
    paymentMethod: paymentMethods !== undefined ? {
      _in: paymentMethods.map(PaymentMethod.toRawString)
    } : undefined,
    deviceIds: deviceIds !== undefined ? {
      _in: deviceIds
    } : undefined
  };
}
function refundReceiptsQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: refundReceiptsQueryVariablesFilterBy(param.filters),
    orderBy: [refundReceiptsQueryVariablesOrderBy(param.sorting)]
  };
}
function creditNotesQueryVariablesFilterBy(param) {
  let date = param.date;
  let customerId = param.customerId;
  let shopId = param.shopId;
  let deviceIds = encodeValues(param.deviceIds);
  return {
    shopIds: shopId !== undefined ? {
      _in: [shopId]
    } : undefined,
    createdAt: date !== undefined ? {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(date[0]), Scalar.Datetime.serialize(date[1])]
    } : undefined,
    customerId: customerId !== undefined ? {
      _in: [Primitive_option.fromNullable(Primitive_option.valFromOption(customerId))]
    } : undefined,
    deviceIds: deviceIds !== undefined ? {
      _in: deviceIds
    } : undefined
  };
}
function creditNotesQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: creditNotesQueryVariablesFilterBy(param.filters),
    orderBy: [creditNotesQueryVariablesOrderBy(param.sorting)]
  };
}
function deliveryNotesQueryVariablesFilterBy(param) {
  let date = param.date;
  let billed = param.billed;
  let customerId = param.customerId;
  let shopId = param.shopId;
  let statuses = unionIn(param.statuses, status => {
    switch (status) {
      case "Draft":
        return ["DRAFT"];
      case "Completed":
        return ["PUBLISHED"];
      default:
        return;
    }
  });
  let deviceIds = encodeValues(param.deviceIds);
  return {
    shopIds: shopId !== undefined ? {
      _in: [shopId]
    } : undefined,
    createdAt: date !== undefined ? {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(date[0]), Scalar.Datetime.serialize(date[1])]
    } : undefined,
    customerId: customerId !== undefined ? {
      _in: [Primitive_option.fromNullable(Primitive_option.valFromOption(customerId))]
    } : undefined,
    date: undefined,
    status: statuses !== undefined ? {
      _in: statuses
    } : undefined,
    billingStatus: billed !== undefined ? billed ? {
      _in: ["BILLED"]
    } : {
      _in: ["NOT_BILLED"]
    } : undefined,
    deviceIds: deviceIds !== undefined ? {
      _in: deviceIds
    } : undefined
  };
}
function deliveryNotesQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: deliveryNotesQueryVariablesFilterBy(param.filters),
    orderBy: [deliveryNotesQueryVariablesOrderBy(param.sorting)]
  };
}
function quotesQueryVariablesFilterBy(param) {
  let date = param.date;
  let billed = param.billed;
  let customerId = param.customerId;
  let shopId = param.shopId;
  let statuses = unionIn(param.statuses, status => {
    switch (status) {
      case "Started":
        return ["PUBLISHED"];
      case "Completed":
        return ["ACCEPTED"];
      default:
        return;
    }
  });
  let deviceIds = encodeValues(param.deviceIds);
  return {
    shopIds: shopId !== undefined ? {
      _in: [shopId]
    } : undefined,
    createdAt: date !== undefined ? {
      _after: undefined,
      _before: undefined,
      _between: [Scalar.Datetime.serialize(date[0]), Scalar.Datetime.serialize(date[1])]
    } : undefined,
    customerId: customerId !== undefined ? {
      _in: [Primitive_option.fromNullable(Primitive_option.valFromOption(customerId))]
    } : undefined,
    status: statuses !== undefined ? {
      _in: statuses
    } : undefined,
    billingStatus: billed !== undefined ? billed ? {
      _in: ["BILLED"]
    } : {
      _in: ["NOT_BILLED"]
    } : undefined,
    deviceIds: deviceIds !== undefined ? {
      _in: deviceIds
    } : undefined
  };
}
function quotesQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last,
    filterBy: quotesQueryVariablesFilterBy(param.filters),
    orderBy: [quotesQueryVariablesOrderBy(param.sorting)]
  };
}
function use$6(saleType, shops, sortingEnabledOpt, hiddenColumnKeysOpt, electronicInvoicingShopSelectedOpt, electronicInvoicingFeatureStateOpt, routerOptions) {
  let sortingEnabled = sortingEnabledOpt !== undefined ? sortingEnabledOpt : true;
  let hiddenColumnKeys = hiddenColumnKeysOpt !== undefined ? hiddenColumnKeysOpt : [];
  let electronicInvoicingShopSelected = electronicInvoicingShopSelectedOpt !== undefined ? electronicInvoicingShopSelectedOpt : false;
  let electronicInvoicingFeatureState = electronicInvoicingFeatureStateOpt !== undefined ? electronicInvoicingFeatureStateOpt : "NotAsked";
  let match = Navigation.useUrl();
  let onCustomerRoute = CustomerRoutes.isCustomerRoute(match.pathname);
  let tmp;
  switch (saleType) {
    case "Invoice":
      tmp = I18n.t("Issuing & Due date");
      break;
    case "DeliveryNote":
      tmp = I18n.t("Delivery date");
      break;
    default:
      tmp = I18n.t("Issuing date");
  }
  let tableColumns = [{
    key: "name",
    name: I18n.t("Number & related document"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 210
      },
      width: {
        NAME: "fr",
        VAL: 1.5
      },
      sticky: true
    },
    allowsSorting: true,
    render: param => {
      let match = param.data;
      let reference = match.reference;
      let saleType = match.saleType;
      let saleTransformed;
      let exit = 0;
      switch (saleType) {
        case "Invoice":
        case "SalesReceipt":
        case "CreditNote":
          exit = 1;
          break;
        default:
          saleTransformed = false;
      }
      if (exit === 1) {
        saleTransformed = Stdlib_Option.mapOr(reference.relatedReferences.invoices, false, invoices => invoices.length !== 0);
      }
      let label = reference.name;
      let labelVariation;
      switch (saleType) {
        case "CreditNote":
        case "RefundReceipt":
          labelVariation = "negative";
          break;
        default:
          labelVariation = "neutral";
      }
      let labelStartElement = svgFromSaleType(saleType);
      let labelEndElement = saleTransformed ? renderTransformedSaleTooltipSvg(saleType) : null;
      let sublabel;
      let exit$1 = 0;
      switch (saleType) {
        case "Invoice":
        case "RefundReceipt":
          exit$1 = 1;
          break;
        default:
          sublabel = Stdlib_Option.flatMap(reference.relatedReferences.invoices, invoices => {
            let invoices$1 = invoices.toSorted((current, next) => Primitive_float.compare(next.date.getTime(), current.date.getTime()));
            return Stdlib_Option.map(invoices$1[0], param => param.name);
          });
      }
      if (exit$1 === 1) {
        sublabel = Stdlib_Option.map(reference.relatedReferences.salesReceipt, param => param.name);
      }
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        labelVariation: labelVariation,
        labelStartElement: labelStartElement,
        labelEndElement: labelEndElement,
        sublabel: sublabel,
        href: SalesRoutes.showRoute(saleType, match.id),
        routerOptions: routerOptions,
        inPrimaryColumn: true
      });
    }
  }, {
    key: "customer",
    name: I18n.t("Customer"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      },
      width: {
        NAME: "fr",
        VAL: 1.5
      }
    },
    render: param => {
      let match = param.data;
      let customer = match.customer;
      if (customer === undefined) {
        if (saleType === "Invoice" || saleType === "CreditNote") {
          return JsxRuntime.jsx(Placeholder.Empty.make, {});
        } else {
          return JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Walk-in customer"),
            variation: "normal",
            size: "xsmall",
            italic: true
          });
        }
      }
      let business = customer.business;
      let name = customer.name;
      let id = customer.id;
      let loyaltyProgramMember = customer.loyaltyProgramMember && Loyalty.isAddonActivated(shops, match.source.shopId);
      let sublabel = Customer.Kind.toLabel(business ? "Business" : "Individual");
      let sublabelEndElement = JsxRuntime.jsx(Customer.Badge.make, {
        business: business,
        loyaltyProgramMember: loyaltyProgramMember,
        size: "xsmall"
      });
      let href = Stdlib_Option.map(id, CustomerRoutes.showRoute);
      let registered = Stdlib_Option.isSome(id);
      let labelStartElement = JsxRuntime.jsx(Offset.make, {
        children: registered ? JsxRuntime.jsx(Icon.make, {
          name: "contact_ok",
          fill: "#535165",
          width: 13,
          height: 13
        }) : null,
        top: 7,
        width: 13,
        height: 13
      });
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: name,
        labelStartElement: labelStartElement,
        sublabel: sublabel,
        sublabelEndElement: sublabelEndElement,
        tooltip: JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [JsxRuntime.jsx(Tooltip.Span.make, {
            text: name,
            bold: true
          }), JsxRuntime.jsx(Tooltip.Gap.make, {
            space: "xxsmall"
          }), JsxRuntime.jsx(Tooltip.Span.make, {
            text: registered ? I18n.t("Registered customer") : I18n.t("Unregistered customer")
          })]
        }),
        href: href
      });
    }
  }, {
    key: "date",
    name: tmp,
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 90
      },
      width: {
        NAME: "fr",
        VAL: 1
      }
    },
    allowsSorting: true,
    render: param => {
      let match = param.data;
      let dueDate = match.dueDate;
      let dueDateSvg = JsxRuntime.jsx(LegacyIcon.make, {
        name: "queue_arrow_right_light",
        fill: "#535165",
        size: 11
      });
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: DateHelpers.formateToShortDate(match.date),
        sublabel: Stdlib_Option.map(dueDate, DateHelpers.formateToShortDate),
        sublabelStartElement: Stdlib_Option.map(dueDate, param => dueDateSvg)
      });
    }
  }, {
    key: "total-amount",
    name: I18n.t("Amount VAT incl."),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 95
      },
      width: {
        NAME: "fr",
        VAL: 1
      }
    },
    allowsSorting: true,
    render: param => {
      let totalAmounts = param.data.totalAmounts;
      let match = Sale.toRevenueImpactTotalAmounts(saleType, totalAmounts.includingTaxes, totalAmounts.excludingTaxes);
      let totalAmountIncludingTaxes = match[0];
      let decreaseInRevenueTransaction = totalAmountIncludingTaxes < 0;
      let total = I18n.currencyFormat(undefined, "EUR", undefined, undefined, totalAmountIncludingTaxes);
      let label = totalAmounts.taxesIncluded ? total : total + " " + I18n.t("VAT excl.");
      let labelVariation = decreaseInRevenueTransaction ? "negative" : "neutral";
      let sublabel = totalAmounts.taxesIncluded ? I18n.currencyFormat(undefined, "EUR", undefined, undefined, match[1]) + " " + I18n.t("VAT excl.") : undefined;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        labelBold: true,
        labelVariation: labelVariation,
        sublabel: sublabel
      });
    }
  }, {
    key: "status",
    name: I18n.t("Statuses"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 180
      },
      width: {
        NAME: "fr",
        VAL: 1.2
      }
    },
    render: param => {
      let match = param.data;
      let status = match.status;
      let match$1 = match.reference;
      let refundReason = match$1.refundReason;
      let relatedReferences = match$1.relatedReferences;
      let saleType = match.saleType;
      let statusBilled = Stdlib_Option.mapOr(relatedReferences.invoices, false, invoices => invoices.length !== 0) && (saleType === "DeliveryNote" || saleType === "Quote");
      let primaryStatusBadge;
      if (status !== undefined) {
        let exit = 0;
        switch (status) {
          case "Completed":
            if (Stdlib_Option.isSome(refundReason)) {
              primaryStatusBadge = JsxRuntime.jsx(make, {
                value: "Completed",
                saleType: saleType,
                refundReason: refundReason
              });
            } else {
              exit = 1;
            }
            break;
          case "Canceled":
            let invoices = relatedReferences.invoices;
            let exit$1 = 0;
            let creditNotes = relatedReferences.creditNotes;
            if (creditNotes !== undefined && creditNotes.items.length !== 0) {
              primaryStatusBadge = JsxRuntime.jsx(make, {
                value: "Canceled",
                saleType: saleType,
                progressAmountPercent: creditNotes.settledPercent,
                creditNotesDetails: creditNotes.items.map(param => ({
                  label: param.name,
                  date: param.date
                }))
              });
            } else {
              exit$1 = 2;
            }
            if (exit$1 === 2) {
              if (invoices !== undefined && invoices.length !== 0) {
                primaryStatusBadge = JsxRuntime.jsx(make, {
                  value: "Canceled",
                  saleType: saleType,
                  invoiceDetails: invoices.map(param => ({
                    label: param.name,
                    date: param.date
                  }))
                });
              } else {
                exit = 1;
              }
            }
            break;
          default:
            exit = 1;
        }
        if (exit === 1) {
          let progressAmountPercent = Stdlib_Option.map(match.paymentBalance, param => param.paidPercent);
          primaryStatusBadge = JsxRuntime.jsx(make, {
            value: status,
            saleType: saleType,
            progressAmountPercent: progressAmountPercent,
            refundReason: refundReason
          });
        }
      } else {
        primaryStatusBadge = JsxRuntime.jsx(Placeholder.NA.make, {});
      }
      let invoices$1 = relatedReferences.invoices;
      let secondaryStatusBadge;
      let exit$2 = 0;
      if (invoices$1 !== undefined && statusBilled) {
        secondaryStatusBadge = JsxRuntime.jsx(make$1, {
          value: "Billed",
          details: invoices$1.map(param => ({
            label: param.name,
            date: param.date
          }))
        });
      } else {
        exit$2 = 1;
      }
      if (exit$2 === 1) {
        let refundReceipts = relatedReferences.refundReceipts;
        let exit$3 = 0;
        let deliveryNotes = relatedReferences.deliveryNotes;
        if (deliveryNotes !== undefined && deliveryNotes.length !== 0) {
          secondaryStatusBadge = JsxRuntime.jsx(make$1, {
            value: "Delivered",
            details: deliveryNotes.map(param => ({
              label: param.name,
              date: param.date
            }))
          });
        } else {
          exit$3 = 2;
        }
        if (exit$3 === 2) {
          secondaryStatusBadge = refundReceipts !== undefined && refundReceipts.length !== 0 ? JsxRuntime.jsx(make$1, {
            value: "Refunded",
            details: refundReceipts.map(param => ({
              label: param.name,
              date: param.date
            }))
          }) : null;
        }
      }
      return JsxRuntime.jsxs(Inline.make, {
        children: [primaryStatusBadge, secondaryStatusBadge],
        space: "xsmall"
      });
    }
  }, {
    key: "ei-status",
    name: ElectronicInvoicingWorkflowState.label,
    layout: {
      hidden: saleType !== "Invoice" || !electronicInvoicingShopSelected,
      minWidth: {
        NAME: "px",
        VAL: 120
      },
      width: {
        NAME: "fr",
        VAL: 1.2
      }
    },
    render: param => {
      let featureState;
      featureState = typeof electronicInvoicingFeatureState !== "object" ? electronicInvoicingFeatureState : electronicInvoicingFeatureState.TAG === "Reloading" ? electronicInvoicingFeatureState._0.TAG === "Ok" ? electronicInvoicingFeatureState : "Loading" : electronicInvoicingFeatureState._0.TAG === "Ok" ? electronicInvoicingFeatureState : "Loading";
      return JsxRuntime.jsx(ElectronicInvoicingWorkflowState.StatusBadgeContainer.make, {
        featureState: featureState,
        data: param.data.eInvoicingWorkflowState
      });
    }
  }, {
    key: "remainder-amount",
    name: I18n.t("Remainder to pay"),
    layout: {
      hidden: saleType !== "Invoice",
      minWidth: {
        NAME: "px",
        VAL: 105
      },
      width: {
        NAME: "fr",
        VAL: 1
      }
    },
    render: param => {
      let match = param.data;
      let paymentBalance = match.paymentBalance;
      let status = match.status;
      if (paymentBalance === undefined) {
        return JsxRuntime.jsx(Placeholder.NA.make, {});
      }
      if (status === "Canceled") {
        return JsxRuntime.jsx(Placeholder.NA.make, {});
      }
      let label = I18n.currencyFormat(undefined, "EUR", undefined, undefined, paymentBalance.remainingAmount);
      let labelBold = status !== "Draft";
      let labelVariation;
      if (status !== undefined) {
        switch (status) {
          case "Started":
            labelVariation = {
              NAME: "custom",
              VAL: "#B84C0B"
            };
            break;
          case "Overdue":
            labelVariation = {
              NAME: "custom",
              VAL: "#7C2112"
            };
            break;
          default:
            labelVariation = "neutral";
        }
      } else {
        labelVariation = "neutral";
      }
      let sublabel = Stdlib_Option.map(paymentBalance.paidAmount, paidAmount => I18n.currencyFormat(undefined, "EUR", undefined, undefined, paidAmount) + " " + I18n.t("paid"));
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        labelBold: labelBold,
        labelVariation: labelVariation,
        sublabel: sublabel,
        sublabelVariation: "normal"
      });
    }
  }, {
    key: "payment-method",
    name: I18n.t("Payment method"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 140
      },
      width: {
        NAME: "fr",
        VAL: 1
      },
      margin: "none"
    },
    render: param => {
      let paymentMethods = param.data.paymentMethods;
      if (paymentMethods === undefined) {
        return JsxRuntime.jsx(Placeholder.NA.make, {});
      }
      let groupedPaymentMethods = groupPaymentMethodsByOccurrence(paymentMethods);
      let newrecord = {
        ...{
          style: {
            maskImage: "linear-gradient(to right, black 0, black 80%, transparent 90%)",
            width: "115%"
          }
        }
      };
      return JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Inline.make, {
        children: groupedPaymentMethods.map((param, index) => JsxRuntime.jsx(PaymentMethod.Badge.make, {
          value: param[0],
          quantity: param[1],
          shortened: true,
          bordered: true
        }, index.toString())),
        space: "xsmall"
      }), newrecord));
    }
  }, {
    key: "payment-date",
    name: I18n.t("Payment date"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 95
      }
    },
    render: param => {
      let match = param.data;
      let paymentDates = match.paymentDates;
      let paymentMethods = match.paymentMethods;
      let ref = React.createRef();
      if (paymentDates === undefined) {
        return JsxRuntime.jsx(Placeholder.NA.make, {});
      }
      let label = DateHelpers.formateToShortDate(paymentDates.primary);
      let sublabel = isDatetimeBackdated(paymentDates.primary) ? "(" + I18n.t("backdated") + ")" : DateHelpers.formateToShortTime(undefined, paymentDates.primary);
      let hasDetails = Stdlib_Option.getOr(paymentDates.all, []).length > 1;
      let detailsTooltipIcon;
      if (hasDetails) {
        let match$1 = paymentDates.all;
        let tmp;
        if (match$1 !== undefined && paymentMethods !== undefined) {
          let paymentItems = match$1.map((date, index) => {
            let paymentMethod = paymentMethods[index];
            return {
              label: paymentMethod !== undefined ? PaymentMethod.toLabel(paymentMethod) : "",
              date: date
            };
          });
          tmp = renderTooltipContent(paymentItems, date => {
            if (isDatetimeBackdated(date)) {
              return I18n.t("Paid on {{date}} (backdated)");
            } else {
              return I18n.t("Paid on {{date}} at {{time}}");
            }
          });
        } else {
          tmp = null;
        }
        detailsTooltipIcon = JsxRuntime.jsx(Offset.make, {
          children: JsxRuntime.jsx(TooltipIcon.make, {
            children: tmp,
            variation: "quiet_more",
            altTriggerRef: ref,
            iconSize: 13
          }),
          left: 2,
          width: 13,
          height: 13
        });
      } else {
        detailsTooltipIcon = null;
      }
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        labelEndElement: detailsTooltipIcon,
        sublabel: sublabel,
        ref: ref
      });
    }
  }, {
    key: "source",
    name: I18n.t("Source"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 150
      },
      width: {
        NAME: "fr",
        VAL: 0
      }
    },
    render: param => {
      let match = param.data.source;
      let deviceLabel = match.deviceLabel;
      let sublabel = shops.length > 1 ? StringHelpers.truncateWithMiddleEllipsis(match.shopName, 23) : undefined;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: deviceLabel,
        sublabel: sublabel,
        tooltip: JsxRuntime.jsx(Tooltip.Span.make, {
          text: deviceLabel
        })
      });
    }
  }, {
    key: "actions",
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 48
      },
      width: {
        NAME: "px",
        VAL: 48
      },
      alignX: "flexEnd",
      sticky: true
    },
    render: param => {
      let match = param.data;
      let customerId = Stdlib_Option.flatMap(match.customer, param => param.id);
      return JsxRuntime.jsx(Offset.make, {
        children: JsxRuntime.jsxs(MenuActions.make, {
          children: [JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("See document"),
            href: SalesRoutes.showRoute(match.saleType, match.id),
            routerOptions: routerOptions,
            icon: "variant_see"
          }), customerId !== undefined && !onCustomerRoute ? JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("See customer"),
            href: CustomerRoutes.showRoute(customerId),
            icon: "contact_ok"
          }) : null],
          trigger: {
            TAG: "Compact",
            icon: "more_v2",
            variant: "subtle",
            size: "small",
            bold: true
          }
        }),
        right: -10,
        width: 48,
        height: 32
      });
    }
  }];
  return tableColumns.map(column => {
    if (column.allowsSorting !== true || sortingEnabled) {
      return column;
    }
    let newrecord = {
      ...column
    };
    newrecord.allowsSorting = false;
    return newrecord;
  }).filter(column => !hiddenColumnKeys.some(key => key === column.key));
}
let SalesTableColumns = {
  use: use$6
};
function mergeQueryResults(salesQueryResult, electronicInvoicingQueryResult, skip) {
  if (skip) {
    return salesQueryResult;
  }
  if (typeof electronicInvoicingQueryResult === "object") {
    return salesQueryResult;
  }
  electronicInvoicingQueryResult === "NotAsked";
  if (typeof salesQueryResult !== "object") {
    return "Loading";
  }
  if (salesQueryResult.TAG === "Reloading") {
    let error = salesQueryResult._0;
    if (error.TAG === "Ok") {
      return "Loading";
    } else {
      return {
        TAG: "Reloading",
        _0: {
          TAG: "Error",
          _0: error._0
        }
      };
    }
  }
  let error$1 = salesQueryResult._0;
  if (error$1.TAG === "Ok") {
    return "Loading";
  } else {
    return {
      TAG: "Done",
      _0: {
        TAG: "Error",
        _0: error$1._0
      }
    };
  }
}
function useInvoicesQueryAsyncResultFn(variablesInput, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, invoicesQueryVariables(variablesInput)));
}
function useSalesReceiptsQueryAsyncResultFn(variablesInput, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, salesReceiptsQueryVariables(variablesInput)));
}
function useRefundReceiptsQueryAsyncResultFn(variablesInput, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, refundReceiptsQueryVariables(variablesInput)));
}
function useCreditNotesQueryAsyncResultFn(variablesInput, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, creditNotesQueryVariables(variablesInput)));
}
function useDeliveryNotesQueryAsyncResultFn(variablesInput, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$4(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, deliveryNotesQueryVariables(variablesInput)));
}
function useQuotesQueryAsyncResultFn(variablesInput, skip) {
  return ApolloHelpers.queryResultToAsyncResult(use$5(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, skip, undefined, quotesQueryVariables(variablesInput)));
}
let defaultQueryHooks = {
  useInvoicesQueryAsyncResult: useInvoicesQueryAsyncResultFn,
  useSalesReceiptsQueryAsyncResult: useSalesReceiptsQueryAsyncResultFn,
  useRefundReceiptsQueryAsyncResult: useRefundReceiptsQueryAsyncResultFn,
  useCreditNotesQueryAsyncResult: useCreditNotesQueryAsyncResultFn,
  useDeliveryNotesQueryAsyncResult: useDeliveryNotesQueryAsyncResultFn,
  useQuotesQueryAsyncResult: useQuotesQueryAsyncResultFn
};
function totalCountFromQueryResult(queryAsyncResult, getTotalCount) {
  if (typeof queryAsyncResult !== "object") {
    if (queryAsyncResult === "NotAsked") {
      return "NotAsked";
    } else {
      return "Loading";
    }
  }
  if (queryAsyncResult.TAG === "Reloading") {
    let result = queryAsyncResult._0;
    if (result.TAG === "Ok") {
      return {
        TAG: "Reloading",
        _0: getTotalCount(result._0)
      };
    } else {
      return "NotAsked";
    }
  }
  let result$1 = queryAsyncResult._0;
  if (result$1.TAG === "Ok") {
    return {
      TAG: "Done",
      _0: getTotalCount(result$1._0)
    };
  } else {
    return "NotAsked";
  }
}
function use$7(saleType, connectionArguments, filters, sorting, searchQuery, queryHooksOpt) {
  let queryHooks = queryHooksOpt !== undefined ? queryHooksOpt : defaultQueryHooks;
  let electronicInvoicingFeatureState = ElectronicInvoicing.useActiveFeatureState(filters.shopId);
  let variablesInput = {
    connectionArguments: connectionArguments,
    searchQuery: searchQuery,
    filters: filters,
    sorting: sorting
  };
  let invoicesQueryResult = queryHooks.useInvoicesQueryAsyncResult(variablesInput, saleType !== "Invoice");
  let skipElectronicInvoicingFeatureState = saleType !== "Invoice" || Stdlib_Option.isNone(filters.shopId);
  let invoicesQueryAsyncResult = mergeQueryResults(invoicesQueryResult, electronicInvoicingFeatureState, skipElectronicInvoicingFeatureState);
  let salesReceiptsQueryAsyncResult = queryHooks.useSalesReceiptsQueryAsyncResult(variablesInput, saleType !== "SalesReceipt");
  let refundReceiptsQueryAsyncResult = queryHooks.useRefundReceiptsQueryAsyncResult(variablesInput, saleType !== "RefundReceipt");
  let creditNotesQueryAsyncResult = queryHooks.useCreditNotesQueryAsyncResult(variablesInput, saleType !== "CreditNote");
  let deliveryNotesQueryAsyncResult = queryHooks.useDeliveryNotesQueryAsyncResult(variablesInput, saleType !== "DeliveryNote");
  let quotesQueryAsyncResult = queryHooks.useQuotesQueryAsyncResult(variablesInput, saleType !== "Quote");
  let totalCount;
  switch (saleType) {
    case "Invoice":
      totalCount = totalCountFromQueryResult(invoicesQueryAsyncResult, param => param.invoices.totalCount);
      break;
    case "SalesReceipt":
      totalCount = totalCountFromQueryResult(salesReceiptsQueryAsyncResult, param => param.salesReceipts.totalCount);
      break;
    case "CreditNote":
      totalCount = totalCountFromQueryResult(creditNotesQueryAsyncResult, param => param.creditNotes.totalCount);
      break;
    case "RefundReceipt":
      totalCount = totalCountFromQueryResult(refundReceiptsQueryAsyncResult, param => param.refundReceipts.totalCount);
      break;
    case "DeliveryNote":
      totalCount = totalCountFromQueryResult(deliveryNotesQueryAsyncResult, param => param.deliveryNotes.totalCount);
      break;
    case "Quote":
      totalCount = totalCountFromQueryResult(quotesQueryAsyncResult, param => param.quotes.totalCount);
      break;
  }
  let pageInfo;
  switch (saleType) {
    case "Invoice":
      if (typeof invoicesQueryAsyncResult !== "object") {
        pageInfo = undefined;
      } else if (invoicesQueryAsyncResult.TAG === "Reloading") {
        let match = invoicesQueryAsyncResult._0;
        if (match.TAG === "Ok") {
          let match$1 = match._0.invoices.pageInfo;
          pageInfo = {
            startCursor: match$1.startCursor,
            endCursor: match$1.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      } else {
        let match$2 = invoicesQueryAsyncResult._0;
        if (match$2.TAG === "Ok") {
          let match$3 = match$2._0.invoices.pageInfo;
          pageInfo = {
            startCursor: match$3.startCursor,
            endCursor: match$3.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      }
      break;
    case "SalesReceipt":
      if (typeof salesReceiptsQueryAsyncResult !== "object") {
        pageInfo = undefined;
      } else if (salesReceiptsQueryAsyncResult.TAG === "Reloading") {
        let match$4 = salesReceiptsQueryAsyncResult._0;
        if (match$4.TAG === "Ok") {
          let match$5 = match$4._0.salesReceipts.pageInfo;
          pageInfo = {
            startCursor: match$5.startCursor,
            endCursor: match$5.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      } else {
        let match$6 = salesReceiptsQueryAsyncResult._0;
        if (match$6.TAG === "Ok") {
          let match$7 = match$6._0.salesReceipts.pageInfo;
          pageInfo = {
            startCursor: match$7.startCursor,
            endCursor: match$7.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      }
      break;
    case "CreditNote":
      if (typeof creditNotesQueryAsyncResult !== "object") {
        pageInfo = undefined;
      } else if (creditNotesQueryAsyncResult.TAG === "Reloading") {
        let match$8 = creditNotesQueryAsyncResult._0;
        if (match$8.TAG === "Ok") {
          let match$9 = match$8._0.creditNotes.pageInfo;
          pageInfo = {
            startCursor: match$9.startCursor,
            endCursor: match$9.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      } else {
        let match$10 = creditNotesQueryAsyncResult._0;
        if (match$10.TAG === "Ok") {
          let match$11 = match$10._0.creditNotes.pageInfo;
          pageInfo = {
            startCursor: match$11.startCursor,
            endCursor: match$11.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      }
      break;
    case "RefundReceipt":
      if (typeof refundReceiptsQueryAsyncResult !== "object") {
        pageInfo = undefined;
      } else if (refundReceiptsQueryAsyncResult.TAG === "Reloading") {
        let match$12 = refundReceiptsQueryAsyncResult._0;
        if (match$12.TAG === "Ok") {
          let match$13 = match$12._0.refundReceipts.pageInfo;
          pageInfo = {
            startCursor: match$13.startCursor,
            endCursor: match$13.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      } else {
        let match$14 = refundReceiptsQueryAsyncResult._0;
        if (match$14.TAG === "Ok") {
          let match$15 = match$14._0.refundReceipts.pageInfo;
          pageInfo = {
            startCursor: match$15.startCursor,
            endCursor: match$15.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      }
      break;
    case "DeliveryNote":
      if (typeof deliveryNotesQueryAsyncResult !== "object") {
        pageInfo = undefined;
      } else if (deliveryNotesQueryAsyncResult.TAG === "Reloading") {
        let match$16 = deliveryNotesQueryAsyncResult._0;
        if (match$16.TAG === "Ok") {
          let match$17 = match$16._0.deliveryNotes.pageInfo;
          pageInfo = {
            startCursor: match$17.startCursor,
            endCursor: match$17.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      } else {
        let match$18 = deliveryNotesQueryAsyncResult._0;
        if (match$18.TAG === "Ok") {
          let match$19 = match$18._0.deliveryNotes.pageInfo;
          pageInfo = {
            startCursor: match$19.startCursor,
            endCursor: match$19.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      }
      break;
    case "Quote":
      if (typeof quotesQueryAsyncResult !== "object") {
        pageInfo = undefined;
      } else if (quotesQueryAsyncResult.TAG === "Reloading") {
        let match$20 = quotesQueryAsyncResult._0;
        if (match$20.TAG === "Ok") {
          let match$21 = match$20._0.quotes.pageInfo;
          pageInfo = {
            startCursor: match$21.startCursor,
            endCursor: match$21.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      } else {
        let match$22 = quotesQueryAsyncResult._0;
        if (match$22.TAG === "Ok") {
          let match$23 = match$22._0.quotes.pageInfo;
          pageInfo = {
            startCursor: match$23.startCursor,
            endCursor: match$23.endCursor
          };
        } else {
          pageInfo = undefined;
        }
      }
      break;
  }
  let loading;
  switch (saleType) {
    case "Invoice":
      loading = AsyncResult.isReloading(invoicesQueryAsyncResult);
      break;
    case "SalesReceipt":
      loading = AsyncResult.isReloading(salesReceiptsQueryAsyncResult);
      break;
    case "CreditNote":
      loading = AsyncResult.isReloading(creditNotesQueryAsyncResult);
      break;
    case "RefundReceipt":
      loading = AsyncResult.isReloading(refundReceiptsQueryAsyncResult);
      break;
    case "DeliveryNote":
      loading = AsyncResult.isReloading(deliveryNotesQueryAsyncResult);
      break;
    case "Quote":
      loading = AsyncResult.isReloading(quotesQueryAsyncResult);
      break;
  }
  let rows;
  switch (saleType) {
    case "Invoice":
      rows = AsyncResult.mapError(AsyncResult.mapOk(invoicesQueryAsyncResult, invoicesTableRowsFromQueryResult), param => {});
      break;
    case "SalesReceipt":
      rows = AsyncResult.mapError(AsyncResult.mapOk(salesReceiptsQueryAsyncResult, salesReceiptsTableRowsFromQueryResult), param => {});
      break;
    case "CreditNote":
      rows = AsyncResult.mapError(AsyncResult.mapOk(creditNotesQueryAsyncResult, creditNotesTableRowsFromQueryResult), param => {});
      break;
    case "RefundReceipt":
      rows = AsyncResult.mapError(AsyncResult.mapOk(refundReceiptsQueryAsyncResult, refundReceiptsTableRowsFromQueryResult), param => {});
      break;
    case "DeliveryNote":
      rows = AsyncResult.mapError(AsyncResult.mapOk(deliveryNotesQueryAsyncResult, deliveryNotesTableRowsFromQueryResult), param => {});
      break;
    case "Quote":
      rows = AsyncResult.mapError(AsyncResult.mapOk(quotesQueryAsyncResult, quotesTableRowsFromQueryResult), param => {});
      break;
  }
  return {
    rows: rows,
    totalCount: totalCount,
    pageInfo: pageInfo,
    loading: loading,
    electronicInvoicingFeatureState: electronicInvoicingFeatureState
  };
}
let SalesTableData = {
  mergeQueryResults: mergeQueryResults,
  useInvoicesQueryAsyncResultFn: useInvoicesQueryAsyncResultFn,
  useSalesReceiptsQueryAsyncResultFn: useSalesReceiptsQueryAsyncResultFn,
  useRefundReceiptsQueryAsyncResultFn: useRefundReceiptsQueryAsyncResultFn,
  useCreditNotesQueryAsyncResultFn: useCreditNotesQueryAsyncResultFn,
  useDeliveryNotesQueryAsyncResultFn: useDeliveryNotesQueryAsyncResultFn,
  useQuotesQueryAsyncResultFn: useQuotesQueryAsyncResultFn,
  defaultQueryHooks: defaultQueryHooks,
  totalCountFromQueryResult: totalCountFromQueryResult,
  use: use$7
};
function SalesTable$SalesTableView(props) {
  let __compactPlaceholder = props.compactPlaceholder;
  let __hiddenColumnKeys = props.hiddenColumnKeys;
  let data = props.data;
  let hiddenColumnKeys = __hiddenColumnKeys !== undefined ? __hiddenColumnKeys : [];
  let compactPlaceholder = __compactPlaceholder !== undefined ? __compactPlaceholder : false;
  let shops = Auth.useShops();
  let columns = use$6(props.saleType, shops, false, hiddenColumnKeys, Stdlib_Option.isSome(props.filters.shopId), data.electronicInvoicingFeatureState, undefined);
  return JsxRuntime.jsx(TableView.make, {
    data: data.rows,
    columns: columns,
    keyExtractor: keyExtractor,
    hideCard: true,
    compactRows: true,
    compactPlaceholder: compactPlaceholder,
    placeholderEmptyState: props.placeholderEmptyState
  });
}
let SalesTableView = {
  make: SalesTable$SalesTableView
};
function SalesTable(props) {
  let __placeholderEmptyState = props.placeholderEmptyState;
  let __hiddenColumnKeys = props.hiddenColumnKeys;
  let __sorting = props.sorting;
  let filters = props.filters;
  let __first = props.first;
  let saleType = props.saleType;
  let first = __first !== undefined ? __first : 5;
  let sorting = __sorting !== undefined ? __sorting : {
    TAG: "Date",
    _0: "descending"
  };
  let hiddenColumnKeys = __hiddenColumnKeys !== undefined ? __hiddenColumnKeys : [];
  let placeholderEmptyState = __placeholderEmptyState !== undefined ? __placeholderEmptyState : JsxRuntime.jsx(Placeholder.make, {
    status: "NoDataAvailable"
  });
  let data = use$7(saleType, {
    first: first
  }, filters, sorting, undefined, undefined);
  return JsxRuntime.jsx(SalesTable$SalesTableView, {
    saleType: saleType,
    filters: filters,
    data: data,
    hiddenColumnKeys: hiddenColumnKeys,
    placeholderEmptyState: placeholderEmptyState
  });
}
let ElectronicInvoicingWorkflowStateResultFragment;
let initialSaleTypeValue = "Invoice";
let make$3 = SalesTable;
export { ElectronicInvoicingWorkflowStateResultFragment, isDatetimeBackdated, groupPaymentMethodsByOccurrence, initialSaleTypeValue, saleTypeValues, svgFromSaleType, renderTransformedSaleTooltipSvg, SalesListInvoicesQuery, SalesListSalesReceiptsQuery, SalesListCreditNotesQuery, SalesListRefundReceiptsQuery, SalesListDeliveryNotesQuery, SalesListQuotesQuery, renderTooltipContent, SalesListPageStatusBadge, SalesListPageSecondaryStatusBadge, SalesListTableRow, invoicesTableRowsFromQueryResult, salesReceiptsTableRowsFromQueryResult, creditNotesTableRowsFromQueryResult, refundReceiptsTableRowsFromQueryResult, deliveryNotesTableRowsFromQueryResult, quotesTableRowsFromQueryResult, SalesTableQueryFilters, SalesTableSorting, invoicesQueryVariablesOrderBy, salesReceiptsQueryVariablesOrderBy, creditNotesQueryVariablesOrderBy, refundReceiptsQueryVariablesOrderBy, deliveryNotesQueryVariablesOrderBy, quotesQueryVariablesOrderBy, salesReceiptsQueryVariablesFilterBy, salesReceiptsQueryVariables, invoicesQueryVariablesFilterBy, invoicesQueryVariables, refundReceiptsQueryVariablesFilterBy, refundReceiptsQueryVariables, creditNotesQueryVariablesFilterBy, creditNotesQueryVariables, deliveryNotesQueryVariablesFilterBy, deliveryNotesQueryVariables, quotesQueryVariablesFilterBy, quotesQueryVariables, SalesTableColumns, SalesTableData, SalesTableView, make$3 as make };
/* query Not a pure module */